const genericAlertM = {
  verb: "bol",
  create: "vytvorený",
  update: "upravený",
  archive: "archivovaný",
  unarchive: "obnovený",
  destroy: "vymazaný",
  new: "Nový",
  expired: "vypršaný",
  copy: "skopírovaný",
};

const genericAlertF = {
  verb: "bola",
  create: "vytvorená",
  update: "upravená",
  destroy: "vymazaná",
  archive: "archivovaná",
  unarchive: "obnovená",
  new: "Nová",
  expired: "vypršaná",
};

const genericAlertN = {
  verb: "bolo",
  create: "vytvorené",
  update: "upravené",
  destroy: "vymazané",
  archive: "archivované",
  unarchive: "obnovené",
  new: "Nové",
  expired: "vypršané",
};

const sk = {
  action: {
    edit_state: "Zmeniť stav",
    update: "Upraviť",
    load: "Načítať",
    export: "Exportovať",
    back: "Späť",
    next: "Ďalej",
    select: "Vybrať",
    cancel: "Zrušiť",
    create: "Vytvoriť",
    save: "Uložiť",
    save_new: "Uložiť nový",
    send: "Odoslať",
    edit: "Editovať",
    archive: "Archivovať",
    unarchive: "Obnoviť",
    manage_subscription: "Správa odberov",
    delete: "Vymazať",
    destroy: "Vymazať",
    remove_personal_data: "Odstrániť osobné údaje",
    remove: "Odstrániť",
    close: "Zavrieť",
    duplicate: "Vytvoriť kópiu",
    all: "Všetky",
    apply: "Aplikovať",
    link: "Nalinkovať",
    unlink: "Odlinkovať",
    impersonate: "Vydávať sa za",
    add_text: "Pridať {type}",
    add_material: "Pridať materiál",
    add_work: "Pridať prácu",
    add_transport: "Pridať dopravu",
    add_note: "Pridať poznámku",
    add_note_draft: "Pokračovať v poznámke",
    add_transition: "Pridať prechod",
    create_threat: "Vytvoriť hrozbu",
    create_vulnerability: "Vytvoriť zraniteľnosť",
    create_control: "Vytvoriť opatrenie",
    add_field: "Pridať pole",
    add_section: "Pridať sekciu",
    add_provision: "Pridať ustanovenie",
    create_price_item: "Vytvoriť položku",
    like: "Páči sa mi",
    dislike: "Nepáči sa mi",
    publish: "Publikovať",
    withdraw_article: "Zrušiť publikovanie",
  },
  app_parts: {
    about: "O aplikácii",
    account: "Účet",
    activities: "Aktivity",
    app_settings: "Nastavenia aplikácie",
    articles: "Články",
    main_administration: "Administrácia",
    asset_categories: "Kategórie majetku",
    asset_groups: "Skupiny aktív",
    assets: "Majetok",
    audits: "Audity",
    automated_actions: "Automatické akcie",
    background_jobs: "Práce na pozadí",
    connectors: "Konektory",
    contracts: "Zmluvy",
    controls_management: "Riadenie opatrení",
    dashboard_screens: "Dashboardy",
    data_sets: "Filtre",
    devices: "Zariadenia",
    document_settings: "Nastavenia dokumentov",
    documents: "Dokumenty",
    standby_plan: "Plán pohotovostí",
    external_emails: "Externé emaily",
    fields: "Polia",
    feedback: "Spätná väzba",
    holidays: "Sviatky",
    consequences: "Následky",
    main_implementation: "Implementácia",
    import_assets: "Import majetku",
    import_contracts: "Import zmlúv",
    import_documents: "Import dokumentov",
    import_fields: "Import polí",
    import_holidays: "Import sviatkov",
    import_issues: "Import hlásení",
    import_controls: "Import opatrení",
    import_persons: "Import osôb",
    import_price_items: "Import položiek",
    import_price_lists: "Import cenníkových položiek",
    import_rules: "Import pravidiel",
    import_services: "Import služieb",
    import_standards: "Import noriem",
    import_tag_definitions: "Import tagov",
    import_templates: "Import šablón",
    import_threats: "Import hrozieb",
    import_threat_categories: "Import kategórií hrozieb",
    import_translations: "Import prekladov",
    import_users: "Import používateľov",
    import_issue_priorities: "Import priorít hlásení",
    import_person_relations: "Import vzťahov osôb",
    import_vulnerabilities: "Import zraniteľností",
    import_warehouses: "Import skladových položiek",
    installation: "Inštalácia",
    issue_priorities: "Priority hlásení",
    issues: "Hlásenia",
    kpis: "KPI",
    license: "Licencia",
    mail_server: "Emailový server",
    main_assets: "Majetok",
    main_audits: "Audity",
    main_connectors: "Konektory",
    main_dashboard_screens: "Dashboardy",
    main_documents: "Dokumenty",
    main_issues: "Hlásenia",
    main_persons: "Osoby",
    main_risk_management: "Riadenie rizík",
    main_services: "Služby",
    main_warehouses: "Sklady",
    maintenance_plan: "Plán údržby",
    mappers: "Priradenia",
    controls: "Opatrenia",
    notice: "Oznam",
    notifications: "Notifikácie",
    permissions: "Oprávnenia",
    person_relations: "Vzťahy osôb",
    person_categories: "Kategórie osôb",
    persons: "Osoby",
    planning_calendar: "Plánovací kalendár",
    preferences: "Preferencie",
    price_items: "Položky",
    price_lists: "Cenníky",
    likelihoods: "Pravdepodobnosti",
    profile: "Profil",
    portal: "Self-service portál",
    public_form: "Verejný formulár pre nahlasovanie",
    reports: "Reporty",
    risk_management: "Riadenie rizík",
    risk_levels: "Úrovne rizík",
    risks: "Analýza rizík",
    roles: "Roly",
    rules: "Pravidlá",
    services: "Služby",
    main_settings: "Nastavenia",
    snippets: "Preddefinované texty",
    standard_soas: "Vyhlásenia o aplikovateľnosti",
    standards: "Normy",
    statistics: "Štatistika",
    subscriptions: "Odbery",
    tag_definitions: "Tagy",
    threats: "Hrozby",
    threat_categories: "Kategórie hrozieb",
    translations: "Preklady",
    user_settings: "Predvolené nastavenia používateľov",
    users: "Používatelia",
    vulnerabilities: "Zraniteľnosti",
    warehouses: "Sklady",
    teams: "Tímy",
    knowledge_base: "Znalostná báza",
  },
  form: {
    hint: {
      global_search: "Hľadať podľa názvu...",
      knowledge_base_search: "Hľadať v znalostnej báze...",
      knowledge_base_search_hint:
        "Nájdite odpovede, návody a často kladené otázky...",
      all_tasks:
        "Vyfiltruje aj úlohy ktoré niesu aktívne (Hlásenie sa nachádza v inom stave ako je stav potrebný pre vykonanie úlohy)",
    },
    placeholder: {
      date: "RRRR-MM-DD",
      time: "HH:MM",
    },
    label: {
      acceptable: "Akceptovateľná",
      activity_type: "Typ aktivity",
      activity: {
        entity_id: "ID objektu",
        entity_type: "Typ objektu",
        person_id: "Autor - Osoba",
        connector_id: "Autor - Konektor",
      },
      aggregate: "Agregácia",
      all_tasks: "Všetky úlohy",
      apply: "Aplikovať",
      apply_from: "Aplikovať od",
      apply_to: "Aplikovať do",
      archive_all: "Archivovať objekt so všetkými podradenými položkami",
      archived_at: "Archivované",
      asset_category_id: "Kategória majetku",
      asset_group_id: "Skupina aktív",
      asset_id: "Majetok",
      asset_with_children: "S podradenými položkami",
      attempts: "Pokusy",
      audit_id: "Audit",
      author: "Autor",
      author_system: "Autor - Systém",
      auto_center: "Automatické centrovanie",
      automated_action_id: "Autor - Automatická akcia",
      automated_action_type: "Typ automatickej akcie",
      availability: "Dostupnosť",
      available_for_limited_users:
        "Dostupný v Self-service portáli pre limitovaných používateľov",
      blocked: "Blokovaný",
      budget: "Náklady",
      calculation: "Spôsob výpočtu",
      cancel: "Zrušiť",
      clear: "Vyčistiť",
      category_id: "Kategória",
      change_parent: "Zmeniť rodiča všetkým podradeným položkám",
      character: "Písm.",
      closed_at: "Uzavreté",
      code_1: "Kód 1",
      code_2: "Kód 2",
      column_filter: "Filter stĺpcov",
      confidentiality: "Dôvernosť",
      connector_id: "Konektor",
      contract_id: "Zmluva",
      contract_type: "Typ zmluvy",
      count: "Počet",
      created_at: "Vytvorené",
      created_by: "Vytvoril",
      created_from: "Vytvorené od",
      created_to: "Vytvorené do",
      author_id: "Autor - Osoba",
      currency: "Mena",
      current_hint: "0 znamená súčasný",
      current_teams: "Tímy aktuálneho používateľa",
      current_risk_level_id: "Úroveň aktuálneho rizika",
      customer_id: "Zákazník",
      dashboard_screen_id: "Dashboard",
      data_set_id: "Filter",
      data_type: "Dátový typ",
      date_from: "Dátum od",
      date_to: "Dátum do",
      description: "Popis",
      detail: "Pole v detaile",
      detail_on_asset: "Pole v detaile majetku",
      display: "Zobrazenie",
      effective_at: "Účinná dňa",
      email: "Email",
      en: "Preklad EN",
      entity_id: "ID vzťahu",
      entity_type: "Typ objektu",
      error: "Chyba načítania filtra",
      evidence: "Dôkazy",
      expense: "Výdaj",
      external_email_id: "Autor - Externý email",
      failed_at: "Zlyhané",
      feedback_rating: "Hodnotenie spätnej väzby",
      field: "Zoskupiť podľa",
      file: "Súbor",
      file_size_range: "Veľkosť",
      files: "Súbory",
      findings: "Zistenia",
      fixed: "Fixné",
      from: "Od",
      gdpr_privacy_policy: "Podmienky ochrany osobných údajov",
      gtin: "GTIN",
      hide_logo: "Skryť logo",
      id: "ID",
      identifier: "Identifikátor",
      information_unavailable: "Informácia nedostupná",
      integrity: "Integrita",
      issue: {
        person_id: "Zodpovedná osoba",
      },
      issue_category_id: "Kategória hlásenia",
      issue_priority_id: "Priorita",
      issue_types: "Typy hlásení",
      issue_type: "Typ hlásenia",
      kb_admin: "Administrátor znalostnej bázy",
      kpi_id: "KPI",
      key: "Kľúč",
      last: "Posledné",
      mapper_id: "Priradenie",
      maximum: "Maximum",
      control_id: "Opatrenie",
      minimum: "Minimum",
      name: "Názov",
      new_parent: "Presunúť pod rodiča",
      no_value_option_asset: "Zobraziť majetky, v ktorých sa nenachádza {type}",
      no_value_option_document:
        "Zobraziť dokumenty, v ktorých sa nenachádza {type}",
      no_value_option_issue:
        "Zobraziť hlásenia, v ktorých sa nenachádza {type}",
      no_value_option_person: "Zobraziť osoby, v ktorých sa nenachádza {type}",
      no_value_option_requirement:
        "Zobraziť požiadavky, v ktorých sa nenachádza {type}",
      no_value_option_risk: "Zobraziť riziká, v ktorých sa nenachádza {type}",
      note: "Poznámka",
      not_assigned: "Nepriradený",
      not_created_by_responsible: "Hlásenie nevytvorené zodpovednou osobou",
      offset: "Posun",
      on: "Spustená",
      on_page: "na tejto stránke",
      operations: "Operácie",
      operations_header: "Operácie nad vybranými objektmi",
      organization_id: "Organizácia",
      otp_required_for_login: "Dvojfaktorová autentifikácia",
      overlap: "Prekrývať",
      owner: "Vlastník",
      owner_id: "Vlastník",
      paragraph: "§",
      parent_id: "Patrí pod",
      period: "Perióda",
      period_filter_method: "Spôsob filtrovania obdobia",
      persistence: "Existencia",
      person_relation_id: "Vzťah",
      person_category_id: "Kategória osôb",
      person_id: "Osoba",
      picture: "Obrázok",
      point: "Bod",
      price_list_id: "Cenník",
      price_type: "Typ položky",
      properties: "Vlastnosti",
      public: "Verejný",
      public_token_valid: "Iba verejné",
      range: "Rozsah",
      receipt: "Príjem",
      relation_type_id: "ID vzťahu",
      report_id: "Report",
      report_type: "Typ reportu",
      resolve_at: "Vyriešiť do",
      residual_risk_level_id: "Úroveň reziduálneho rizika",
      risk_reduction: "Zníženie rizika",
      risk_level_id: "Úroveň rizika",
      risk_type: "Typ rizika",
      rm_admin: "Administrátor riadenia rizík",
      role_id: "Rola",
      team_id: "Tím",
      reponsible_persons: "Zodpovedné osoby",
      rm_asset_type: "Použité v riadení rizík ako",
      row: "Riadok",
      rule_id: "Autor - Pravidlo",
      run_at: "Spustiť",
      run_type: "Typ spustenia",
      service_id: "Služba",
      service_organization_id: "Servisná organizácia",
      select_all: "Vybrať všetko",
      selected: "vybraných",
      show_legend: "Zobraziť legendu",
      sk: "Preklad SK",
      solution: "Riešenie",
      solve_status: "Stav riešenia",
      sort: "Zoradiť podľa",
      sort_desc: "Zoradiť zostupne",
      standard_id: "Norma",
      standard_soa_id: "Vyhlásenie o aplikovateľnosti",
      start_of_working_hours: "Začiatok pracovného času",
      state: "Stav",
      status: "Stav",
      subscription_type: "Typ odberu",
      subsection: "Ods.",
      sum: "Súčet",
      table_headers: "Stĺpce tabuľky",
      tag_definitions: "Tagy",
      tag_definition_id: "Tag",
      target_entity: "Cieľový dátový typ",
      threat_id: "Hrozba",
      threat_category_id: "Kategória",
      tier: "Typ používateľa",
      till_now: "až po súčasnosť",
      time_filter: "Dátumové pole",
      time_from: "Čas od",
      time_to: "Čas do",
      to: "Do",
      transfer: "Presun",
      type: "Typ",
      unit: "Jednotka",
      updated_at: "Naposledy upravené",
      use_current_user: "Aktuálny používateľ",
      user_id: "Zodpovedná osoba",
      valid_at: "Platné dňa",
      value: "Hodnota",
      value_in_detail: "Hodnota v detaile",
      visualization: "Spôsob zobrazenia",
      vulnerability_id: "Zraniteľnosť",
      warehouse_id: "Sklad",
      with_user: "S používateľom",
      source_warehouse_id: "Zdrojový sklad",
      target_warehouse_id: "Cieľový sklad",
      price_item_id: "Položka",
      whole: "Celé",
      with_children: "S podradenými položkami",
      working_color: "Farba ikony pre majetok bez hlasení",
      working_hide: "Nezobrazovať majetok bez hlásení",
      xtitle: "Popis osi X",
      ytitle: "Popis osi Y",
      zoom: "Priblíženie",
      date: "Dátum",
      time: "Čas",
    },
    error: {
      required: "Toto pole je povinné",
      valid: "Toto pole nie je platné",
      length_min_max: "Musí obsahovať minimálne {min} a maximálne {max}",
      length_min: "Musí obsahovať minimálne {min}",
      length_max: "Musí obsahovať maximálne {max}",
      characters_count: "{n} znak | {n} znaky | {n} znakov",
      json: "Musí obsahovať platný JSON",
      value_min_max: "Hodnota musí byť minimálne {min} a maximálne {max}",
      value_min: "Hodnota musí byť minimálne {min}",
      value_max: "Hodnota musí byť maximálne {max}",
      value_higher: "Hodnota musí byť väčšia ako {value}",
      value_lower: "Hodnota musí byť menšia ako {value}",
      value_higher_equal_zero: "Hodnota musí byť rovná alebo väčšia ako 0",
      value_custom_range:
        "Hodnota musí byť rovná alebo väčšia ako {min} a rovná alebo menšia ako {max}",
      value_higher_equal_0_lower_equal_custom_value:
        "Hodnota musí byť rovná alebo väčšia ako 0 a rovná alebo menšia ako {value}",
      not_zero: "Hodnota nesmie byť 0",
      email: "Musí byť platná emailová adresa",
      multi_email: "Musí obsahovať iba platné emailové adresy",
      big_file: "Veľkosť súboru presahuje limit",
      max_files: "Maximálny počet súborov je {max}",
      not_in_past: "Dátum nesmie byť v minulosti",
      must_contain_number: "Musí obsahovať aspoň jedno číslo",
      must_contain_lower: "Musí obsahovať aspoň jedno malé pismeno",
      must_contain_upper: "Musí obsahovať aspoň jedno veľké písmeno",
      items_min_max:
        "Počet položiek musí byť minimálne {min} a maximálne {max}",
      later_date: "Dátum musí byť neskôr ako '{prev}'",
      match_password: "Musí sa zhodovať s heslom",
    },
  },
  enum: {
    boolean: {
      no: "Nie",
      yes: "Áno",
    },
    week_first_day: {
      monday: "Pondelok",
      sunday: "Nedeľa",
    },
  },
  other: {
    actions: "Akcie",
    info: "Info",
    summary: "Zhrnutie",
    other: "Iné",
    tags: {
      subscribe: "Zapnuté notifikácie",
      children_count: "Počet podradených položiek",
    },
    language: {
      sk: "Slovenský",
      en: "Anglický",
    },
    basic_info: "Základné informácie",
  },
  first_login: {
    cookies:
      "Som si vedomý / vedomá, že aplikácia používa súbory cookies a súhlasím s tým",
    personal_info_GDPR:
      "Súhlasím s ďalším spracovávaním mojich osobných údajov",
    license: "Súhlasím s EULA",
    accept: "Akceptujem",
    decline: "Neakceptujem",
    welcome: "Vitajte v AUSEMIO",
    link_text: "Viac informácií",
    headers: {
      cookies: "O súboroch cookies na týchto stránkach",
      gdpr: "Zbieranie dát",
    },
  },
  tooltips: {
    navbar_icons: {
      log_out: "Odhlásiť sa",
      locales_switch: "Vybrať jazyk",
      notifications: "Notifikácie",
      documentation: "Dokumentácia",
      search: "Použite # + Id číslo pre vyhľadávanie podľa Id",
      search_shortcut: "Vyhľadať ( S )",
      stop_impersonating: "Prestať sa vydávať za používateľa",
      list: "Zobrazenie zoznamu",
      card: "Zobrazenie kariet",
      tree: "Zobrazenie stromu",
      map: "Zobrazenie mapy",
      cal: "Zobrazenie kalendára",
    },
    show_assets_calendar_tooltip: {
      table_view: "Tabuľka",
      graphic_view: "Plán",
    },
    show_buttons: {
      add: "Vytvoriť nový objekt",
      add_new_transition: "Pridať nový prechod medzi stavmi",
      add_shortcut: "Vytvoriť nový objekt ( C )",
      show_previous_note: "Zobraziť predchádzajúcu poznámku",
      hide_previous_note: "Skryť predchádzajúcu poznámku",
      apply_plan_shortcut: "Aplikovať plán ( A )",
      apply_controls: "Aplikovať opatrenia",
      new_note: "Vytvoriť novú poznámku",
      reply_to_note: "Odpovedať",
      reply_to_note_draft: "Pokračovať v odpovedaní na poznámku",
      forward_note: "Preposlať",
      copy_link: "Kopírovať odkaz na túto poznámku",
      create_solution_from_note: "Vytvoriť riešenie z tejto poznámky",
      edit: "Upraviť objekt",
      change_state: "Zmena stavu hlásenia",
      assign_me: "Prevziať hlásenie",
      add_location: "Pridať polohu",
      edit_location: "Upraviť polohu",
      new_document: "Vytvoriť a nalinkovať nový dokument",
      import: "Importovať zo súboru",
      new_material_report: "Výkaz materiálu",
      new_work_report: "Nový výkaz práce",
      new_transport_report: "Nový výkaz dopravy",
      link_object: "Nalinkovať existujúce objekty",
      link_document: "Nalinkovať existujúce dokumenty",
      show_in_documents: "Otvoriť v Dokumentoch",
      show_in_issues: "Otvoriť v Hláseniach",
      run_applying: "Spustiť aplikovanie opatrenia",
      passwd_change: "Zmeniť heslo",
      other: "Ostatné akcie",
      new_option: "Nová možnosť",
      add_issue: "Vytvoriť hlásenie",
      operations: "Operácie ( O )",
      filter: "Filtrovať ( F )",
      filter_inside: "Filtrovať ( Shift + Enter )",
      filter_actions: "Akcie filtra",
      filter_config: "Konfigurácia filtra",
      clear_filter_shortcut: "Zmazať filter ( Shift + Backspace )",
      apply: "Aplikovať",
      setup_permissions: "Nastaviť oprávnenia",
      navigate: "Navigovať",
      download: "Stiahnuť",
      use_translation: "Použiť preklad",
      use_optional_translation: "Použiť text bez prekladu",
      add_DataSet_dashlet: "Pridať dlaždicu typu filter",
      add_Kpi_dashlet: "Pridať dlaždicu typu KPI",
      add_Calendar_dashlet: "Pridať dlaždicu typu kalendár",
      find_by_qr: "Nájdi majetok podľa BAR/QR kódu",
      add_threat: "Vytvoriť a pridať novú hrozbu",
      add_vulnerability: "Vytvoriť a pridať novú zraniteľnosť",
      add_control: "Vytvoriť a pridať nové opatrenie",
      add_section: "Pridať novú sekciu",
      add_provision: "Pridať nové ustanovenie",
      add_price_item: "Vytvoriť novú položku",
      create_template_assignment: "Vytvoriť šablónu",
      apply_planned_control: "Aplikovať planované opatrenie",
      bulk_add_applied: "Označiť vybrané majetky ako aplikované",
      bulk_remove_applied: "Zrušiť aplikovanie pre vybrané majetky",
      bulk_add_planned: "Označiť vybrané majetky ako plánované",
      bulk_remove_planned: "Zrušiť plánované pre vybrané majetky",
      new_task: "Vytvoriť novú úlohu",
      new_sla: "Vytvoriť novú SLA",
      open_task_tab: "Otvoriť úlohy",
      acceptance: "Akceptovanie riešenia hlásenia",
      close_issue: "Uzavrieť hlásenie",
      knowledge_base_search: "Otvoriť znalostnú bázu",
      create_article: "Vytvoriť článok",
    },
    disabled_buttons: {
      add: "Nemáte oprávnenie na vytvorenie nového objektu",
      add_new_transition: "Nemáte oprávnenie pridať nový prechod medzi stavmi",
      new_note: "Nemáte oprávnenie na vytvorenie novej poznámky",
      note_reply: "Nemáte oprávnenie odpovedať na poznámku",
      edit: "Nemáte oprávnenie na úpravu objektu",
      new_location: "Nemáte oprávnenie na vytvorenie novej lokality",
      generic: "Nemáte oprávnenie na túto akciu",
      fields_echo: "Nemáte zadané všetky polia",
      no_filter: "Nemáte aktívny žiadny filter",
      no_issue: "Nie je potrebné nové hlásenie",
      no_warehouse_items: "Táto položka nie je na sklade",
      warehouse_delete: "Zostatok musí byť 0",
      no_batches: "Položka nemá šarže",
    },
    tabs_icons: {
      search: "Vyhľadať",
      save: "Uložiť",
      delete: "Zmazať",
      edit: "Upraviť",
      priority_move_up: "Zvýšiť prioritu",
      priority_move_down: "Znížiť prioritu",
      move_up: "Posunúť hore",
      move_down: "Posunúť dolu",
      checklist_preview: "Náhľad kontrolného z.",
      empty: "Nie je zadefinovaný tooltip !!!",
      add: "Pridať",
      preview: "Náhľad",
      detail: "Zobraziť detail",
      show_in_cal: "Zobraziť všetky zdroje v kalendári",
      history_of_asset_issues: "Zobraziť históriu hlásení na tomto majetku",
    },
    show_archived: "Zobraziť archivované",
    hide_archived: "Skryť archivované",
  },
  generic: {
    application: "Aplikácia",
    archive: "Archivácia",
    back_to_login: "Späť na prihlásenie",
    camera: "Kamera",
    code: "Kód",
    conf_new_passwd: "Potvrdiť nové heslo",
    drop_files_message: "Nahrať súbory presunutím",
    error_value: "Chybný údaj",
    false: "Nie",
    filter_active: "Filter je aktívny",
    forgot: "Zabudli ste heslo?",
    item: "Položka",
    log_in: "Prihlásiť",
    log_in_header: "Prihlásenie",
    message: "Správa",
    new_passwd: "Nové heslo",
    object: "Objekt",
    others: "iných",
    password: "Heslo",
    copyright: "Copyright © 2023",
    reader: "Čítačka",
    run: "Spustiť",
    scan: "Skenovať",
    scan_qr: "Skenovať QR/BAR Kód",
    send_reset: "Obnoviť",
    set_passwd: "Nastaviť nové heslo",
    show_less: "Zobraziť menej",
    show_more: "Zobraziť viac",
    system: "Systém",
    total_count: "Celkový počet",
    true: "Áno",
    two_factor_auth_code: "Overovací kód",
    unknown: "Neznámy",
    unset: "Neurčené",
  },
  date_parts: {
    second: "sekunda",
    minute: "minúta",
    hour: "hodina",
    day: "deň",
    week: "týždeň",
    month: "mesiac",
    year: "rok",
  },
  // TC translations
  minute: "1 minúta | {n} minúty | {n} minút",
  day: "1 deň | {n} dni | {n} dní",
  day_l: "dni | dňoch | dňoch",
  week: "1 týždeň | {n} týždne | {n} týždňov",
  month: "1 mesiac | {n} mesiace | {n} mesiacov",
  year: "1 rok | {n} roky | {n} rokov",
  messages: {
    publicIssue: {
      cameraAllow: "Povoľte kameru pre skenovanie QR kódu",
      noCamera: "Chyba: Kamera nie je dostupná v zariadení",
      httpsNeeded: "HTTPS je potrebné pre skenovanie QR kódu",
      cameraInUse: "Chyba: Nie je kamera práve používaná?",
      cameraFront: "Zariadenie nemá prednú alebo zadnú kameru",
      streamAPI:
        "Chyba: Knižnica na živé vysielanie nie je podporovaná v prehliadači",
    },
    login: {
      success: "Úspešné prihlásenie",
      error: "Nepodarilo sa prihlásiť. Nesprávne meno alebo heslo.",
      error_two_factor: "Nepodarilo sa prihlásiť. Neplaný autentifikačný kód.",
    },
    logout: "Úspešné odhlásenie",
    pageLoadAuthenticationError:
      "Autentifikácia zlyhala. Prosím prihláste sa pre pokračovanie.",
    appPartNoAccess: "Nemáte oprávnenie na túto časť aplikácie",
    passwordReset: {
      error:
        "Chyba nastavenia nového hesla: {errors}. Pre vygenerovanie nového linku na obnovenie hesla kliknite na 'OBNOVIŤ'. Ak sa chyba opakuje, kontaktujte prosím administrátora.",
      success: "Heslo bolo zmenené",
      instructionsSend:
        "Poslali sme Vám odkaz na obnovenie hesla na Váš emailový účet. Postupujte podľa krokov na obnovenie hesla. V prípade nedoručenia prosím skontrolujte spam alebo správnosť zadaného emailu, cez ktorý ste u nás zaregistrovaný.",
      instructionsSendError:
        "Chyba pri posielaní inštrukcií pre resetovanie hesla emailom",
    },
    globalSearchError: "Nie je možné načítať výsledky",
    treeLoadError: "Chyba načítania stromu",
    will_permanently: "bude natrvalo",
    question: "Chcete pokračovať?",
    cant: "Nie je možné",
    noPermissionError: "Nemáte dostatočné oprávnenie.",
    select: "Vyberte",
    noDataListPermissions: "Nemáte oprávnenia na žiadnu položku",
    empty_import_file: "Váš súbor neobsahuje dáta pre import",
    mapTooMuchData:
      "Máte vybraných príliš veľa objektov (viac ako 1000), ktorých súčasné zobrazenie by výrazne zneprehľadnilo a aj spomalilo vizualizáciu na mape. Použite filter pre výber menšej množiny.",
    moreThenAnother: "{firstName} musí byť väčšie ako {secondName}.",
    check: "Pravdepodobne ste nezadali všetky polia správne",
    scanErr: "Neplatný GTIN",
    scanErrorBatch: "Pri tejto naskenovanej položke je povinná šarža",
    notInList: "Položka {name} {batch} nie je na zozname",
    no_icon: "Prosím zvoľte ikonu",
    notInChecklist: "Tento majetok nie je súčasťou tohto kontrolného zoznamu",
    close_transaction:
      "Uzavretie transakcie, pri tomto kroku sa definitívne uzavrie Vaša transakcia, nebude ju možné už zmeniť. ",
    license: {
      user_exceeded:
        "Ďakujeme, že využívate platformu AUSEMIO. Pre pridanie ďalších používateľov, prosím kontaktujte Vášho dodávateľa, prípadne sa na nás obráťte na {web}.",
      connector_exceeded:
        "Ďakujeme, že využívate platformu AUSEMIO. Pre pridanie ďalších konektorov, prosím kontaktujte Vášho dodávateľa, prípadne sa na nás obráťte na {web}.",
    },
    original_parent_archived:
      "Pôvodný rodič je archivovaný, prosím vyberte nového rodiča",
    remove_personal_data:
      "Odstráni osobné údaje v karte osoba a všetky údaje s príznakom osobné údaje v šablónach.",
    personal_data_removed: {
      success: "Osobné údaje boli odstránené.",
      error: "Nie je možné odstrániť osobné údaje.",
    },
    multi_operations: {
      no_objects: "Nie sú vybrané žiadne ${model_plural}",
    },
    impersonate: {
      success: "Práve sa vydávate za používateľa {person}",
    },
    image: {
      tooLarge: "Obrázok je príliš veľký. Maximálna veľkosť je 5MB.",
      uploadFailed: "Nahratie obrázku zlyhalo",
      invalidImageType: "Neplatný typ obrázku",
    },
    solution_missing_warning:
      "Hlásenie nemá riešenie, prosím doplňte riešenie v časti",
    moreResults: "Existujú ďalšie výsledky, prosím upresnite vyhľadávanie.",
  },

  dataTableMessages: {
    filter: {
      name: "Filtrovať položky podľa názvu",
    },
    emptyData: {
      headerPt1: "Nie sú zobrazené dáta pre",
      headerPt2: ", dôvody môžu byť nasledujúce",
      filterReason: "Nastavenému filtru nevyhovujú žiadne dáta",
      emptyDatabaseReason: "V databáze nie su vytvorené dáta",
      permissionReason: "Nemáte oprávnenie na zobrazenie dát ",
      genericEmptyDataMessage:
        "Nie sú vytvorené objekty alebo nemáte oprávnenie na to, aby ste ich videli",
      loading: "Načítavajú sa dáta, prosím počkajte",
      text: "Nenašli sa žiadne výsledky",
      scanner: "Prosím začnite skenovať položky",
      warehouse: "Prosím vyberte sklad",
    },
    bottomNavbar: {
      list: "Zoznam",
      tree: "Strom",
      map: "Mapa",
      card: "Karty",
    },
  },
  sorts: {
    asc: "Vzostupne",
    desc: "Zostupne",
    created_at: {
      asc: "Od najstarších",
      desc: "Od najnovších",
    },
    updated_at: {
      asc: "Dávno",
      desc: "Nedávno",
    },
    discarded_at: {
      asc: "Dávno",
      desc: "Nedávno",
    },
    name: {
      asc: "A - Z",
      desc: "Z - A",
    },
    category: {
      name: {
        asc: "A - Z",
        desc: "Z - A",
      },
    },
    issue_priority_id: {
      asc: "Od najnižšej",
      desc: "Od najvyššej",
    },
  },
  person: {
    person: "Osoba",
    persons: "Osoby",
    acc: "osobu",
    tree: "Strom osôb",
    alert: genericAlertF,
    label: {
      avatar: "Obrázok",
      submenu: {
        new_user: "Vytvoriť používateľa",
      },
      associated_user: "Vytvoriť osobu s pridruženým používateľom",
    },
  },
  asset: {
    asset: "Majetok",
    assets: "Majetok",
    acc: "majetok",
    tree: "Strom majetku",
    card: "Karty majetku",
    alert: genericAlertM,
    label: {
      avatar: "Obrázok",
      applied: "Aplikované",
      properties: "Vlastnosti majetku",
      submenu: {
        new_issue: "Vytvoriť hlásenie",
      },
      dependent: "Závislé od",
      depends: "Závisí na",
      view_all: "Zobraziť",
      type: "Typ aktíva",
      added_assets: "Pridané majetky",
      filtered_assets: "Vyfiltrované majetky",
      add_assets: "Pridať vybraný majetok",
    },
    confidentiality_types: {
      public: "Verejné",
      internal: "Interné",
      protected: "Chránené",
      strictly_protected: "Prísne chránené",
    },
    integrity_types: {
      low: "Nízka",
      medium: "Stredná",
      high: "Vysoká",
    },
    availability_types: {
      low: "Nízka",
      medium: "Stredná",
      high: "Vysoká",
    },
    rm_asset_types: {
      primary: "Primárne aktívum",
      supporting: "Podporné aktívum",
    },
    select_type: "Spôsob výberu majetku",
    asset_filters: "Filtre na majetok",
    search_assets: "Vyhľadať majetok",
  },
  document: {
    document: "Dokument",
    documents: "Dokumenty",
    acc: "dokument",
    label: {
      entity_document: "Priradené objekty",
      dialog_entity_type: "Typ objektu",
      select_objects: "Vyberte objekt",
      less_than_1_mb: "Menej ako 1 MB",
      size: "Veľkosť",
      gallery: "Galéria dokumentov",
      table_view: "Tabuľka",
      gallery_view: "Galéria",
      noPreview: "Ukážka tohto typu súboru nie je k dispozícií",
      preview: "Náhľad",
      public_token_valid: "Verejný",
      attachments: "Prílohy",
      without_relation: "Bez vzťahu",
      submenu: {
        compress: "Komprimovať obrázok",
        new_folder: "Vytvoriť nový priečinok",
        add_doc: "Pridať dokument",
      },
    },
    public_form: {
      sorry: "Nie je možné zobraziť dokument.",
    },
    alert: genericAlertM,
  },
  folder: {
    folder: "Priečinok",
    acc: "priečinok",
    alert: genericAlertM,
    files_location: "Umiestnenie nahrávaných súborov",
  },
  contract: {
    contract: "Zmluva",
    contracts: "Zmluvy",
    acc: "zmluvu",
    alert: genericAlertF,
    contract_types: {
      fixed_prolong: "Zmluva na dobu určitú s automatickým predĺžením",
      fixed_end: "Zmluva na dobu určitú s ukončením",
      indefinite: "Zmluva na dobu neurčitú",
    },
    label: {
      customer: "Zákazník",
      service_organization: "Servisná organizácia",
      contract_type: "Typ zmluvy",
      valid_from: "Platná od",
      effective_from: "Účinná od",
      effective_to: "Účinná do",
      effective_at: "Účinná dňa",
      prolongation_interval: "Interval predĺženia",
      notice_period: "Výpovedná lehota",
      submenu: {},
    },
    hint: {
      customer: "Osoba, ktorá obdrží dodávku služieb",
      service_organization: "Osoba, ktorá zabezpečuje dodávku služieb",
      valid_from: "Začiatok platnosti",
      effective_from: "Začiatok účinnosti",
      effective_to: "Koniec účinnosti a platnosti",
      notice_period: "Obdobie výpovednej lehoty",
      prolongation_interval: "Obdobie o ktoré sa zmluva predĺži",
    },
  },
  service: {
    service: "Služba",
    services: "Služby",
    acc: "službu",
    alert: genericAlertF,
    label: {
      resolve_plan: "Plánované ukončenie",
      resolve_true: "Skutočné ukončenie",
      assets_revisions: "Revízia majetku",
      workflow: "Workflow",
      copy_tasks: "Skopírovať úlohy",
      copy_templates: "Skopírovať šablóny",
      copy_sla: "Skopírovať SLA",
      copy_permissions: "Skopírovať oprávnenia",
      setup_all: "Výber kontrolného zoznamu pre všetky kategórie",
      submenu: {
        new_issue: "Vytvoriť hlásenie",
      },
      allowed_tags: "Povolené tagy",
      working_hours: "Pracovný čas",
      standby_plan: "Plán pohotovostí",
      public: "Verejná služba",
      public_issue_type: "Typ verejného hlásenia",
      issue_categories: "Kategórie",
      predefined_solver: "Preddefinovaný riešiteľ",
      color: "Farebné označenie služby",
    },
    issue_types: {
      Incident: "Incident",
      Request: "Požiadavka",
      Change: "Zmena",
      Problem: "Problém",
    },
    messages: {
      hint: "Diagram bude vygenerovaný na pozadí a súbor bude uložený k dokumentom služby. O dokončení budete informovaný notifikáciou v aplikácii.",
    },
    add_assets_dialog: "Nastavenie majetku pre službu",
  },
  service_link: {
    service_link: "Podporná služba",
    service_links: "Podporné služby",
    acc: "podpornú službu",
    alert: genericAlertF,
    label: {
      service_links_for_incident: "Podporné služby pre incidenty",
    },
  },
  service_person: {
    service_person: "Osoba na službe",
    service_persons: "Osoby na službe",
    acc: "osobu na službe",
    alert: genericAlertF,
  },
  standby_time: {
    standby_time: "Čas pohotovosti",
    standby_times: "Čas pohotovostí",
    acc: "čas pohotovosti",
    alert: genericAlertM,
  },
  rule: {
    rule: "Pravidlo",
    rules: "Pravidlá",
    acc: "pravidlo",
    alert: genericAlertN,
    label: {
      valid_from: "Platné od",
      valid_to: "Platné do",
      repeat: "Opakovať",
      in_advance: "Vytvoriť hlásenie vopred",
      required_by_law: "Vyžadované legislatívou",
      valid_at: "Platné dňa",
      filter: "Definícia filtra",
    },
    tooltip: {
      no_issue: "Nie je priradené žiadne hlásenie",
      missing_resolve_at: "Priradené hlásenie bez dátumu riešenia",
      create_issue: "Vytvoriť inicializačné hlásenie pre vybrané majetky",
      select_asset: "Vyberte aspoň 1 majetok",
    },
    hint: {
      repeat: "Interval medzi jednotlivými prehliadkami",
    },
  },
  calendar: {
    calendar: "Kalendár",
    planning_calendar: "Plánovací kalendár",
    maintenance_plan: "Plán údržby",
    type: "Typ",
    drag: "Presunúť do kalendára",
    drag_tooltip: "Pre presunutie prosím vyberte osobu",
    hours_from: "Vybrané hodiny",
    hours_to: "do",
    week: "Týždeň",
    apply: "Aplikovať plán",
    today: "Dnes",
    label: {
      time_from: "Zobraziť od",
      time_to: "Zobraziť do",
      table_mode: "Tabuľka",
    },
    coloring: {
      label: "Ofarbenie",
      default: "Predvolené",
    },
    types: {
      month: "Mesiac",
      week: "Týždeň",
      day4: "4 dni",
      day: "Deň",
      year: "Rok",
      scheduler: "Plánovač",
    },
    apply_dialog: {
      total: "Celkový počet",
      success: "Úspešne naplánované",
      fail: "Neúspešne naplánované",
      not_changed: "Už naplánované v minulosti",
      source: "Dôvod chyby",
      no_plan_state: "Stav nenakonfigurovaný",
      no_transition: "Prechod nenájdený",
      transition_fail: "Chyba prechodu: {message}",
    },
  },
  issue: {
    issue: "Hlásenie",
    issues: "Hlásenia",
    acc: "hlásenie",
    alert: genericAlertN,
    label: {
      timeline: "Časová os",
      services: "SLA/Služby",
      transactions: "Transakcie",
      change_state: "Zmeniť stav",
      assign_me: "Prevziať",
      create: "Vytvorenie",
      update: "Úprava",
      destroy: "Zmazanie",
      difference: "Rozdiel",
      to: "na",
      identifier: "Identifikátor",
      public_token_valid: "Verejný",
      public_link: "Verejný odkaz",
      assets_from_filter:
        "Hlásenie bude vytvorené s {n} položkou majetku | Hlásenie bude vytvorené s {n} položkami majetku | Hlásenie bude vytvorené s {n} položkami majetku",
      planned_at: "Naplánované dňa",
      resolve_at: "Vyriešiť do",
      closed_at: "Uzavreté",
      resolve_from: "Vyriešiť od",
      resolve_to: "Vyriešiť do",
      change_status_dialog: "Zmena stavu hlásenia",
      no_state: "Žiaden stav",
      and_more: " a ďalšie {number}",
      solution: "Riešenie",
      write_solution: "Napísať riešenie",
      use_existing_note_as_solution: "Použiť poznámku",
      copy_note_as_solution: "Skopírovať poznámku",
      copy_from_existing_note:
        "Skopírovať obsah z existujúcej poznámky (voliteľné)",
      select_note_to_mark_as_solution:
        "Vyberte poznámku na označenie ako riešenie",
      mark_as_solution: "Označiť ako riešenie",
      display_closed: "Zobraziť uzavreté hlásenia",
      submenu: {
        link_issue: "Prepojené hlásenia",
      },
      issues_history: "História hlásení",
      change_service: "Zmena služby",
      switch_to_service: "Presunúť na službu",
      requested_service: "Požadovaná služba",
      requested_state: "Požadovaný stav",
      type: "Typ hlásenia",
      tasks: "Úlohy",
      status: "Stav",
      assigned_person: "Zodpovedná osoba",
      acceptance: "Akceptácia",
      accept: "Akceptujem riešenie hlásenia",
      refuse: "Neakceptujem riešenie hlásenia",
      change_assigned_person: "Zmena zodpovednej osoby",
      add_assigned_person: "Pridať zodpovednú osobu",
      assign_person_first:
        "Pre plánovanie je potrebné najskôr priradiť zodpovednú osobu na hlásenie",
      planning_allowed:
        "Plánovanie je teraz pre hlásenie {issue_name} povolené",
      change_priority: "Zmena priority",
      correct: "Oprava hlásenia",
      close: "Uzavrieť",
      links: "Prepojenia",
      method_of_closure: "Spôsob uzavretia",
      issue_detail: "Údaje hlásenia",
      custom_fields: "Vlastné polia",
    },
    close_reasons: {
      duplicate: "Uzavrieť ako duplikát",
      invalid: "Uzavrieť ako neplatné",
      known_error: "Uzavrieť ako známu chybu",
    },
    hint: {
      service: "Služba, v rámci ktorej má byť hlásenie riešené",
    },
    public_form: {
      new: "Nové Hlásenie",
      continue: "Ďalej",
      back: "Späť",
      skip: "Preskočiť",
      qr_code: "Porucha na",
      email: "Váš kontaktný email",
      title: "Nahlásenie poruchy",
      title_files: "Máte súbory vzťahujúce sa k hláseniu?",
      description_files:
        "K Vášmu hláseniu je možné priložiť až 5 fotografií prípadne iných súborov.",
      title_qr: "Je na nahlasovanom  majetku viditeľný QR kód?",
      description_qr:
        "Naskenovanie QR kódu na pokazenom majetku môže pomôcť lepšie identifikovať problém. " +
        "Ak nevidíte žiadny QR kód alebo Vaše zariadenie nemá fotoaparát, môžete tento krok preskočit.",
      title_contact: "Kontakt na Vás",
      location_header: "Chcete uložiť presnú polohu hlásenia?",
      description_location:
        "Uloženie aktuálnej polohy nám môže pomôcť rýchlejšie nájsť problém.",
      location_save: "Uložiť aktuálnu polohu",
      location_info:
        "Pre uloženie aktuálnej polohy je potrebné mať v prehliadači povolené zdieľanie polohy. " +
        "V prípade, že ste zdieľanie polohy zakázali a chcete používať polohu " +
        "je potrebné toto nastavenie zmeniť a znovu načítať stránku.",
      description_contact:
        "Nechajte nám prosím kontakt. " +
        "Je potrebný pre prípadnú komunikáciu a informovanie o vyriešení požiadavky.",
      title_thank: "Ďakujeme za Vaše hlásenie",
      description_thank:
        "Stav hlásenia budete môcť sledovať cez odkaz poslaný na email",
      sorry: "Nie je možné zobraziť hlásenie.",
    },
    issue_types: {
      Incident: "Incident",
      Request: "Požiadavka",
      Change: "Zmena",
      Problem: "Problém",
    },
    statuses: {
      new: "Nové",
      assigned: "Priradené",
      resolution: "Rieši sa",
      resolution_waiting: "Čakajúce v riešení",
      approval_waiting: "Čakajúce v schvaľovaní",
      assessment_waiting: "Čakajúce v posudzovaní",
      planning_waiting: "Čakajúce v plánovaní",
      analysis_waiting: "Čakajúce v analyzovaní",
      testing_waiting: "Čakajúce v testovaní",
      deploying_waiting: "Čakajúce v nasadzovaní",
      resolved: "Vyriešené",
      closed: "Uzavreté",
      assessment: "Posudzuje sa",
      planning: "Plánuje sa",
      analysis: "Analyzuje sa",
      approval: "Schvaľuje sa",
      invalid: "Neplatné",
      known_error: "Známa chyba",
      rejected: "Neschválené",
      duplicate: "Duplikát",
      testing: "Testuje sa",
      deploying: "Nasadzuje sa",
    },
    feedback: {
      title: "Ohodnoťte Vašu skúsenosť",
      subtitle: "Ako ste spokojný s vyriešením?",
      additional_feedback: "Dodatočná spätná väzba (voliteľné)",
      message_label: "Vaša správa",
      message_placeholder:
        "Prosím, zdieľajte akékoľvek pripomienky alebo návrhy...",
      rating_required: "Prosím, vyberte hodnotenie",
      rating_select: "Kliknite pre hodnotenie",
      thank_you_title: "Ďakujeme za Vašu spätnú väzbu!",
      thank_you_message:
        "Vaše hodnotenie bolo úspešne odoslané. Vážime si, že ste si našli čas podeliť sa o svoju skúsenosť.",
      error_message:
        "Toto hlásenie už bolo ohodnotené. Nie je možné ho hodnotiť opakovane.",
    },
    feedback_ratings: {
      0: "Žiadne hodnotenie",
      1: "Veľmi nespokojný",
      2: "Nespokojný",
      3: "Priemerný",
      4: "Spokojný",
      5: "Veľmi spokojný",
    },
  },
  issue_category: {
    issue_category: "Kategória hlásenia",
    issue_categories: "Kategórie hlásení",
    acc: "kategóriu hlásenia",
    alert: genericAlertF,
  },
  task: {
    task: "Úloha",
    tasks: "Úlohy",
    acc: "úlohu",
    alert: genericAlertF,
    label: {
      range: "Rozsah",
      time: "Konkrétny čas",
      plan_start: "Plánovaná od",
      plan_end: "Plánovaná do",
      resource: "Zdroj",
      resources: "Zdroje",
      relation: "Vzťah",
      person: "Priradená osoba",
      type: "Typ úlohy",
      approve: "Schváliť",
      disapprove: "Zamietnuť",
      done: "Označiť ako ukončená",
      undone: "Označiť ako nespravená",
      status: "Stav",
      begin: "Začať",
      close: "Ukončiť",
      opinion: "Stanovisko",
      waiting: "Čakať",
      resume: "Pokračovať",
      reopen: "Znovu otvoriť",
      display_all: "Zobraziť všetky úlohy",
      close_task: "Ukončiť úlohu",
      description: "Popis úlohy:",
      asset_checklist: "Kontrolný zoznam",
      task_checklist: "Kontrolný zoznam",
      work_reports_count: "Počet pracovných výkazov",
      inform_requester: "Odoslať žiadateľovi emailom na {email}",
    },
    statuses: {
      inactive: "Neaktívna",
      new: "Nová",
      in_progress: "V riešení",
      done: "Ukončená",
      undone: "Nespravená",
      in_approval: "V schvaľovaní",
      waiting: "Čakajúca",
      approved: "Schválená",
      unapproved: "Neschválená",
    },
  },
  task_template: {
    task_template: "Šablóna úlohy",
    task_templates: "Šablóny úloh",
    acc: "šablónu úlohy",
    alert: genericAlertF,
    label: {
      task_type: "Typ úlohy",
      task_types: "Typ úloh",
      general: "Všeobecná",
      approval: "Schvaľovanie",
      in: "Príjem na sklad",
      out: "Výdaj zo skladu",
      transfer: "Presun medzi skladmi",
      asset_checklist: "Kontrolný zoznam majetku",
      task_checklist: "Kontrolný zoznam úlohy",
      task_status: "Stav úlohy",
      issue_status: "Stav hlásenia",
      task_resolver_type: "Typ riešiteľa úlohy",
      previous_task_completed: "Spustiť po dokončení úloh",
      task_chain: "Reťazec úloh",
    },
    validation: {
      task_cycle_detected:
        "Objavená kruhová závislosť úloh. Odstráňte úlohy, ktoré by vytvorili cyklus.",
      self_task: "Úloha nemôže závisieť sama od seba.",
    },
    warnings: {
      task_cycle_detected:
        "Upozornenie: Tento výber úloh môže vytvoriť kruhovú závislosť.",
    },
    execution: {
      will_start_after: "sa spustí po",
      parallel_tasks: "Tieto úlohy môžu bežať paralelne.",
      sequential_task: "Táto úloha sa musí dokončiť ako prvá.",
      sequential_task_chain:
        "Tieto úlohy tvoria postupný reťazec a musia sa vykonávať v poradí.",
    },
    task_resolver_types: {
      user: "Používateľ",
      team: "Tím",
      team_owner: "Vlastník tímu",
      service_owner: "Vlastník služby",
      issue_author: "Autor hlásenia",
      responsible_user: "Zodpovedná osoba hlásenia",
      reporter: "Zadávateľ hlásenia",
    },
  },
  task_user: {
    task_user: "Priradenie používateľa k úlohe",
    task_users: "Priradenie používateľov k úlohám",
    acc: "priradenie používateľa k úlohe",
    alert: genericAlertN,
  },
  kpi: {
    kpi: "KPI",
    kpis: "KPI",
    acc: "KPI",
    alert: genericAlertN,
    label: {
      computed_at: "Vypočítané o",
      refresh_rate: "Perióda obnovenia",
      data: "Dáta",
      preview: "Náhľad",
      definition: "Definícia",
      visualization: "Spôsob zobrazenia",
      calculation: "Spôsob výpočtu",
      key: "Možnosť",
      value: "Hodnota",
      next: "Ďalej",
      back: "Späť",
      legend: "Legenda",
      count: "Počet",
      no_issues: "Bez hlásení",
      error: "Chyba výpočtu KPI",
      no_data: "Žiadne dáta. Skontrolujte nastavenia",
      submenu: {
        compute_now: "Prepočítať hneď",
      },
      team_kpi: "Tímové KPI",
    },
    refresh_rates: {
      0: "Žiadna",
      60: "1 Hodina",
      360: "6 Hodín",
      1440: "24 Hodín",
    },
    visualizations: {
      map: "Mapa",
      pie_chart: "Koláčový graf",
      donut_chart: "Prstencový graf",
      column_chart: "Stĺpcový graf",
      bar_chart: "Riadkový graf",
      line_chart: "Čiarový graf",
      area_chart: "Plošný graf",
      time_line: "Časová os",
      stacked_column_chart: "Vrstvený stĺpcový graf",
      stacked_bar_chart: "Vrstvený riadkový graf",
      table: "Tabuľka",
    },
    calculations: {
      ratio: "Pomer",
      average: "Priemerné @.lower:form.label.feedback_rating",
      issue_count: "Počty hlásení",
      sla_count: "Počty SLA",
      risk_count: "Počty rizík",
      sla_overview: "Prehľad SLA",
      time_series: "Časové rady",
      detail_sum: "Súčet podľa poľa v detaile",
      map: "Mapa",
      map_colored: "Mapa podľa priority",
      transaction_item_sum: "Súčet transakčných položiek",
    },
    display_type: {
      percentage: "Percentá",
      value: "Hodnota",
      label: "Názov",
      none: "Bez zobrazenia",
    },
  },
  connector: {
    connector: "Konektor",
    connectors: "Konektory",
    acc: "konektor",
    alert: genericAlertM,
    label: {
      type: "Typ",
      status: "Status",
      on: "Spustený",
      connector_type: "Typ konektora",
      login: "Prihlasovacie meno",
      url: "URL",
      queries: "Definícia dopytov",
      mail_receiver: {
        host: "Host",
        imap_port: "IMAP port",
        smtp_port: "SMTP port",
        user_name: "Prihlasovacie meno",
      },
      mail_ms_graph: {
        tenant_id: "Tenant ID",
        client_id: "Client ID",
        mailbox: "Mailbox",
        folders: "Priečinky",
        filter: "Filter",
        additional_bcc: "Dodatočná Bcc adresa",
      },
      ldap: {
        port: "Port",
        bases: "Adresáre",
        filter: "Filter",
        attributes: "Atribúty",
      },
      ftp: {
        path: "Cesta k zdrojovému priečinku",
      },
      without: "Bez konektora",
    },
    type: {
      mail_receiver: "IMAP",
      mail_ms_graph: "MS Graph email",
      ldap: "LDAP",
      ftp: "FTP sťahovanie",
      ftp_sender: "FTP nahrávanie",
      sftp: "SFTP sťahovanie",
      sftp_sender: "SFTP nahrávanie",
      ca_sdm: "CA SDM REST",
      dpd_sap: "DPD SAP REST",
      document_saver: "Ukladač dokumentov",
      qualys: "Qualys",
      sccm: "SCCM",
      jira: "Jira",
      ausemio: "AUSEMIO",
      otrs: "OTRS",
    },
  },
  connector_run: {
    connector_run: "Spustenie",
    connector_runs: "Spustenia",
    acc: "spustenie",
    alert: genericAlertN,
  },
  connector_result: {
    connector_result: "Výsledok konektora",
    connector_results: "Výsledky konektora",
    acc: "výsledok konektora",
    alert: genericAlertM,
  },
  mapper: {
    mapper: "Priradenie",
    mappers: "Priradenia",
    acc: "priradenie",
    alert: genericAlertN,
    label: {
      mapper_type: "Typ priradenia",
      definition: "Definícia",
    },
    mapper_types: {
      mail_receiver_mapper: "Hlásenia z emailu",
      csv_mapper: "CSV -> majetok/osoby/hlásenia",
      csv_generator: "Majetok/osoby/hlásenia -> CSV",
      json_mapper: "JSON -> majetok/osoby",
      viskb_xml_generator: "Majetok -> VISKB XML",
    },
  },
  external_email: {
    external_email: "Externý email",
    external_emails: "Externé emaily",
    acc: "externý email",
    alert: genericAlertM,
    label: {
      submenu: {},
    },
  },
  permission: {
    permission: "Oprávnenie",
    permissions: "Oprávnenia",
    acc: "oprávnenie",
    selection: "Typ objektu",
    selectTypeAndUser: "Vyberte typ objektu a používateľa",
    tooltip: {
      see: "Vidieť",
      create: "Vytvoriť",
      update: "Upraviť",
      destroy: "Vymazať",
      see_in_object: "Vidieť v rámci objektu",
      update_in_object: "Upraviť v rámci objektu",
      see_issues: "Vidieť hlásenia",
    },
    menu: {
      unset: "Nenastavené",
      unchanged: "Nezmenené",
      allowObject: "Povolené",
      allowObjectAndChildren: "Povolené s dedením",
      denyObject: "Zakázané",
      denyObjectAndChildren: "Zakázané s dedením",
    },
    label: {
      type: "Typ",
      permitted_persons: "Oprávnené osoby",
      persons_text_1: "Osoba",
      persons_text_2: "a všetky deti v organizačnej štruktúre.",
      roles_text_1: "Všetky osoby priradené k role",
      assignee: "(Oprávnenie z priradenia)",
      detail: "Detail oprávnenia",
      multiple_setup: "Nastaviť pre vybrané",
      entity: "Objekt",
      owner: "Vlastník oprávnenia",
    },
  },
  role: {
    role: "Rola",
    roles: "Roly",
    acc: "rolu",
    alert: genericAlertF,
    label: {
      configuration: "Konfigurácia",
    },
  },
  team: {
    team: "Tím",
    teams: "Tímy",
    acc: "tím",
    alert: genericAlertM,
  },
  user: {
    user: "Používateľ",
    users: "Používatelia",
    acc: "používateľa",
    alert: genericAlertM,
    label: {
      block_status: "Blokovaný",
      two_factor_auth: "Dvojfaktorová autentifikácia",
      status: "Stav",
      is_turned_on: " je zapnutá",
      turn_on: "Zapnúť",
      is_turned_off: " je vypnutá",
      turn_off: "Vypnúť",
      turn_2fa_off: "Vypnúť dvojfaktorovú autentifikáciu",
      confirm: "Potvrdiť",
      two_factor_auth_label:
        "Naskenujte QR kód aplikáciou pre dvojfaktorovú autentifikáciu. Zadajte vygenerovaný kód a potvrďte.",
      submenu: {
        resend_instructions: "Poslať inštrukcie na obnovenie hesla",
      },
      impersonate: "Vydávať sa za používateľa",
      phone: "Telefónne číslo",
      user_tree: "Strom používateľov",
    },
    hint: {
      roles: "Vyberte roly, ktoré prislúchajú používateľovi",
      teams: "Vyberte tímy, ktoré prislúchajú používateľovi",
    },
    tier_types: {
      implementer: "Implementátor",
      admin: "Administrátor",
      full: "Plný prístup",
      limited: "Limitovaný prístup",
      technical: "Technický prístup",
    },
  },
  asset_category: {
    asset_category: "Kategória majetku",
    asset_categories: "Kategórie majetku",
    acc: "kategóriu",
    alert: genericAlertF,
  },
  person_category: {
    person_category: "Kategória osôb",
    person_categories: "Kategórie osôb",
    acc: "kategóriu",
    alert: genericAlertF,
  },
  category: {
    category: "Kategória",
    categories: "Kategórie",
    acc: "kategóriu",
    alert: genericAlertF,
    label: {
      parents: "Nadradené kategórie",
      icon: "Ikona",
      persons: "Osoby",
      organization: "Organizácia",
      basic: "Základné",
      buildings: "Budovy",
      security: "Bezpečnosť",
      cars: "Autá",
      ikt: "Informačné a komunikačné technológie",
      cyber_sec: "Kybernetická bezpečnosť",
      energetics: "Energetika",
      use_in_risk_management: "Použiť v riadení rizík ako",
      submenu: {
        new_cat: "Vytvoriť novú kategóriu",
        existing_cat: "Pridať existujúcu kategóriu",
      },
    },
  },
  template: {
    template: "Šablóna",
    templates: "Šablóny",
    acc: "šablónu",
    alert: genericAlertF,
    detail: "Detail",
    empty: "K objektu nie je možné evidovať detail",
    raw: "Nespracované dáta",
    name: "Názov šablóny",
    label: {
      definition: "Definícia",
      key: "Kľúč",
      type: "Typ",
      templates_on_categories: "Šablóny na kategóriách osôb/majetku",
      uniqueLastValue: "Najvyššia hodnota",
      yes: "Áno",
      no: "Nie",
      field: "Pole",
      data_type: "Dátový typ",
      new_field: "Nové pole",
      new_option: "Nová možnosť",
      form: "Formulár",
      required: "Povinné",
      unique: "Unikátne",
      personal: "Osobný údaj",
      notify: "Notifikovať",
      submenu: {},
      fields: "Polia",
      multiselect: "Viacnásobný výber",
      conditional: "Zapnúť podmienený výber",
      select_from: "Podmienené výberom z",
      option: "Možnosť",
      show_on_public_page: "Verejné hlásenie",
      show_on_public_map: "Verejná mapa",
      full_user_only: "Nezobrazuje sa limitovaným používateľom",
    },
  },
  field: {
    field: "Pole",
    fields: "Polia",
    acc: "pole",
    alert: genericAlertN,
    label: {
      data_type: "Dátový typ",
      hint: "Tip pri vypĺňaní",
    },
    data_types: {
      String: "Krátky text",
      Text: "Dlhý text",
      Integer: "Číslo",
      Date: "Dátum",
      Time: "Čas",
      Boolean: "Zaškrtávacie pole",
      Switch: "Prepínač",
      Select: "Výber z viacerých",
      Radio: "Označenie z viacerých",
      Document: "Dokument",
      Person: "Osoba",
      Asset: "Majetok",
      Issue: "Hlásenie",
      Password: "Heslo",
      DateTime: "Dátum a čas",
    },
  },
  field_assignment: {
    field_assignment: "Priradenie poľa",
    field_assignments: "Priradenia polí",
    acc: "priradenie poľa",
    alert: genericAlertN,
  },
  price_item: {
    price_item: "Položka",
    price_items: "Položky",
    acc: "položku",
    label: {
      price_type: "Typ položky",
      unit: "Jednotka",
      base: "Základná položka",
      batch: "Šarža",
      batches: "Šarže",
      quantity: "Množstvo",
      price: "Cena",
      gtin: "GTIN",
      code_1: "Kód 1",
      code_2: "Kód 2",
      submenu: {},
    },
    price_types: {
      material: "Materiál",
      work: "Práca",
      transport: "Doprava",
    },
    batch: {
      dialog: {
        header: "Zoznam šarží",
      },
      name: "Názov šarže",
      expiration: "Dátum exspirácie",
      quantity: "Množstvo",
      warehouse_quantity: "Na sklade",
      alert: "Na sklade sú položky so skoršou exspiráciou",
    },
    units: {
      // weight
      grams: "gramy",
      kilograms: "kilogramy",
      tons: "tony",
      ounces: "unce",
      pounds: "libry",
      // length
      millimeters: "milimetre",
      centimeters: "centimetre",
      meters: "metre",
      kilometers: "kilometre",
      feet: "stopy",
      miles: "míle",
      // area
      square_meters: "štvorcové metre",
      ares: "áre",
      hectares: "hektáre",
      square_feet: "štvorcové stopy",
      acres: "akre",
      // volume
      milliliters: "mililitre",
      liters: "litre",
      hectoliters: "hektolitre",
      cubic_meters: "kubické metre",
      pints: "pinty",
      gallons: "galóny",
      // time
      seconds: "sekundy",
      minutes: "minúty",
      hours: "hodiny",
      days: "dni",
      weeks: "týždne",
      months: "mesiace",
      years: "roky",
      // IT
      megabytes: "megabajty",
      gigabytes: "gigabajty",
      terabytes: "terabajty",
      // electric
      kilowatt_hours: "kilowatthodiny",
      milli_ampere_hours: "miliampérhodiny",
      // other
      pieces: "kusy",
      packages: "balenia",
      pallets: "palety",
      executions: "úkony",
      man_hours: "človeko-hodiny",
      engine_hours: "moto-hodiny",
      man_days: "človeko-dni",
    },
    units_short: {
      // weight
      grams: "g",
      kilograms: "kg",
      tons: "t",
      ounces: "oz",
      pounds: "lb",
      // length
      millimeters: "mm",
      centimeters: "cm",
      meters: "m",
      kilometers: "km",
      feet: "ft",
      miles: "mi",
      // area
      square_meters: "m²",
      ares: "ar",
      hectares: "ha",
      square_feet: "ft²",
      acres: "acre",
      // volume
      milliliters: "ml",
      liters: "l",
      hectoliters: "hl",
      cubic_meters: "m³",
      pints: "pt",
      gallons: "gal",
      // time
      seconds: "s",
      minutes: "min",
      hours: "hod",
      days: "d",
      weeks: "t",
      months: "mes",
      years: "r",
      // IT
      megabytes: "MB",
      gigabytes: "GB",
      terabytes: "TB",
      // electric
      kilowatt_hours: "kWh",
      milli_ampere_hours: "mAh",
      // other
      pieces: "ks",
      packages: "bal",
      pallets: "pal",
      executions: "úk",
      man_hours: "čl. hod",
      engine_hours: "moto hod",
      man_days: "čl. d",
    },
    alert: genericAlertF,
  },
  price_items_price_list: {
    price_items_price_list: "Cenníková položka",
    price_items_price_lists: "Cenníkové položky",
    acc: "cenníkovú položku",
    alert: genericAlertF,
  },
  warehouse: {
    warehouse: "Sklad",
    warehouses: "Sklady",
    acc: "sklad",
    alert: genericAlertM,
    label: {
      balance: "Zostatok",
      quantity: "Počet",
      warehouse_from: "Zo skladu",
      warehouse_to: "Na sklad",
      price_summary: "Celková cena",
      min: "Min.",
      opt: "Opt.",
      minimal: "Minimálne množstvo",
      optimal: "Optimálne množstvo",
      under_limit: "Prekročené minimálne množstvo",
      warehouse_transactions: "Transakcie",
      transaction_type: "Typ",
      changed_at: "Zmenené",
      transfer_to: "Presunúť na iný sklad",
      status: "Stav",
      submenu: {
        make_transaction: "Pridať materiál",
      },
      transactions: {
        in: "Príjem",
        out: "Výdaj",
        transfer: "Presun",
        transfer_from: "Presun zo skladu",
        transfer_to: "Presun na sklad",
      },
      statuses: {
        pending: "Rozpracovaná",
        closed: "Uzavretá",
      },
    },
    dialog: {
      limit_header: "Nastavenie limitov",
      start: "Spustiť skenovanie položiek",
      scanner_header: "Skener položiek",
      add_manually: "Pridať položku manuálne",
      manual_header: "Pridanie položky",
    },
    messages: {
      transactionError: "Zadajte aspoň jednu zmenu",
    },
  },
  price_list: {
    price_list: "Cenník",
    price_lists: "Cenníky",
    acc: "cenník",
    alert: genericAlertM,
    label: {
      price: "Cena",
      prices: "Ceny",
      unit_price: "Jednotková cena",
      currency: "Mena",
      valid_from: "Platný od",
      valid_to: "Platný do",
      submenu: {
        setup_prices: "Nastaviť ceny",
      },
    },
  },
  work_report: {
    work_report: "Výkaz práce",
    work_reports: "Výkazy práce",
    acc: "výkaz práce",
    alert: genericAlertM,
    label: {
      price_list: "Použitý cenník: ",
      quantity: "Množstvo",
      object: "Sklad / Osoba / Majetok",
      author: "Vytvoril",
      summary: "Celková spotreba s nákladmi",
      items: "Jednotlivé položky výkazu",
      total_price: "Celková cena",
      submenu: {},
      type: "Typ výkazu",
    },
  },
  checklist: {
    checklist: "Kontrolný zoznam",
    checklists: "Kontrolné zoznamy",
    acc: "kontrolný zoznam",
    alert: genericAlertM,
  },
  template_assignment: {
    template_assignment: "Priradenie šablóny k objektu",
    template_assignments: "Priradenia šablón k objektom",
    acc: "priradenie šablóny k objektu",
    alert: genericAlertN,
    label: {
      edit_header: "Priradenie šablóny",
      status: "Overenie šablóny pri prechode do stavu",
    },
    usage: "Použitie",
  },
  dashboard_screen: {
    dashboard_screen: "Dashboard",
    dashboard_screens: "Dashboardy",
    acc: "dashboard",
    new_dashboard: "Nový dashboard",
    refresh_rates: {
      0: "Žiadna",
      1: "1 Minúta",
      5: "5 Minút",
      15: "15 Minút",
    },
    alert: genericAlertM,
    label: {
      refresh_rate: "Perióda obnovenia",
      team_dashboard: "Tímový dashboard",
    },
  },
  dashlet: {
    dashlet: "Dlaždica",
    dashlets: "Dlaždice",
    acc: "dlaždicu",
    alert: genericAlertF,
    label: {
      order: "Poradie",
      size: "Šírka",
      setup_error: "Dlaždica nie je nastavená",
    },
    sizes: {
      2: "16 %",
      3: "25 %",
      4: "33 %",
      6: "50 %",
      8: "66 %",
      9: "75 %",
      12: "100 %",
    },
  },
  subscription: {
    subscription: "Odber",
    subscriptions: "Odbery",
    acc: "odber",
    alert: genericAlertM,
    label: {
      subscription_type: "Typ odberu",
      subscribed_items: "Odoberané položky",
      type: "Typ",
      last_one: "Je potrebné vybrať aspoň jednu voľbu",
      issue_priority: "Pri akej priorite?",
    },
    subscription_types: {
      Service: "Služby",
      Contract: "Zmluvy",
      Rule: "Pravidlá",
      Asset: "Majetok",
      AssetCategory: "Kategórie majetku",
      Person: "Osoby",
      PersonCategory: "Kategórie osôb",
      Warehouse: "Sklady",
      PriceItem: "Cenníkové položky",
      Connector: "Konektory",
      Mapper: "Priradenia",
      AutomatedAction: "Automatické akcie",
      Other: "Iné",
    },
  },
  entity_subscription: {
    entity_subscription: "Odoberaný objekt",
    acc: "odoberaný objekt",
    alert: genericAlertM,
  },
  notification: {
    notification: "Notifikácia",
    notifications: "Notifikácie",
    acc: "notifikáciu",
    alert: genericAlertF,
    label: {
      empty: "Nemáte žiadne neprečítané notifikácie",
      from: "Od",
      mark_as_read: "Označit ako prečítanú",
      open_object: "Prejdite na tento objekt",
      notifications_list: "Zoznam notifikácií",
      on_object: "na objekt",
      read: "Prečítaná",
      read_all: "Označiť všetky ako prečítané",
      view_all: "Zobraziť všetky",
      created: "Vytvorená",
      notification_send_when: "Notifikácia bude odoslaná",
      when: "Kedy chcete byť notifikovaný?",
      how: "Ako chcete byť notifikovaný?",
      time: "Čas",
      before_expire: "Čas oznámenia pred vypršaním",
      before_batch_expire: "Čas oznámenia pred vypršaním šarže",
      before_notice_period: "Čas oznámenia pred začiatkom výpovednej lehoty",
    },
    types: {
      issue_create: "Pri vytvorení hlásenia",
      issue_close: "Pri uzavretí hlásenia",
      update: "Pri úprave objektu",
      fail: "Keď zlyhá konektor",
      mention: "Keď som spomenutý v poznámke na hlásení",
      note_create: "Keď je vytvorená nová poznámka na hlásení",
      assign: "Keď som priradený na hlásenie",
      assign_to_task: "Keď som priradený na úlohu",
      team_issue: "Keď je vytvorené hlásenie pre môj tím",
      team_task: "Keď je úloha priradená môjmu tímu",
      unassigned_task:
        "Keď je na hlásení, za ktoré som zodpovedný, aktívna úloha bez priradenia",
      expire: "Keď vyprší platnosť",
      prolong: "Pri predĺžení",
      before_notice_period: "Pred začiatkom výpovednej lehoty",
      before_expire: "Predtým než vyprší platnosť",
      optimal_balance: "Keď sa prekročí optimálny počet",
      minimal_balance: "Keď sa prekročí minimálny počet",
      before_batch_expire: "Pred exspiráciou šarže",
      batch_expire: "Pri exspirácii šarže",
      response_time_expire: "Keď skončí čas zareagovania",
      before_response_time_expire: "Pred koncom času na zareagovanie",
      resolution_time_expire: "Keď skončí čas vyriešenia ",
      before_resolution_time_expire: "Pred koncom času na vyriešenie",
      issue_state_enter: "V konkrétnom stave ",
      run_error: "Keď dôjde k chybe pri spustení",
      my_issue_resolve: "Keď je moje hlásenie vyriešené",
      my_issue_close: "Keď je moje hlásenie uzavreté",
      my_issue_note_create: "Keď je vytvorená nová poznámka na mojom hlásení",
      assigned_issue_note_create:
        "Keď je na hlásení, za ktoré som zodpovedný, vytvorená nová poznámka",
      only_issue_author: "Iba ak je poznámka vytvorená autorom hlásenia",
      assigned_issue_note_create_only_issue_author:
        "Keď je na hlásení, za ktoré som zodpovedný, vytvorená nová poznámka autorom hlásenia",
    },
    tooltip: {
      mail: "Notifikácia cez email",
      push: "Push notifikácia",
      sms: "SMS notifikácia",
    },
  },
  snippet: {
    snippet: "Preddefinovaný text",
    snippets: "Preddefinované texty",
    acc: "preddefinovaný text",
    alert: genericAlertM,
    label: {
      value: "Hodnota",
      team_snippet: "Tímový preddefinovaný text",
    },
  },
  entity_document: {
    entity_document: "Priradenie dokumentu k objektu",
    entity_documents: "Priradenia dokumentov k objektom",
    acc: "priradenie dokumentu k objektu",
    dialog: {
      from_document: "Nalinkovať objekty",
      from_entity: "Nalinkovať dokumenty",
      hint: "Pre vyhľadávanie začnite písať",
    },
    alert: genericAlertN,
  },
  location: {
    location: "Poloha",
    locations: "Polohy",
    acc: "polohu",
    alert: genericAlertF,
    label: {
      latitude: "Zemepisná šírka",
      longitude: "Zemepisná dĺžka",
      loadName: "Načítať názov",
      layers: "Vrstvy",
      cadastre: "Katastrálna",
      basic: "Základná",
      public_issue_map: "Mapa hlásení",
      current: "Načítať aktuálnu polohu",
    },
    tooltip: {
      getCoordinates: "Získať súradnice podľa názvu miesta",
      disabled: {
        getCoordinates: "Zadajte celý názov miesta",
        current: "Prístup k polohe bol odmietnutý",
      },
    },
    hint: {
      latitude: "Zadajte v desatinnom formáte",
      longitude: "Zadajte v desatinnom formáte",
    },
    select_location: "Pre zmenu polohy kliknite na mapu",
  },
  issue_note: {
    issue_note: "Poznámka",
    issue_notes: "Poznámky",
    acc: "poznámku",
    alert: genericAlertF,
    note_types: {
      internal: "Interná",
      public: "Verejná",
      solution: "Riešenie",
      external: "Externá",
      description: "Popis",
    },
    label: {
      from: "Od: ",
      displaying: "Zobrazené",
      send_email: "Poslať poznámku emailom",
      email_to: "Adresát",
      email_cc: "Kópia",
      email_bcc: "Skrytá kópia",
      loadMore: "Načítať viac",
      note_type: "Typ poznámky",
      linkCopied: "Odkaz na poznámku bol skopírovaný",
      new: "Nová poznámka",
      forward: "Preposlať {type} poznámku",
      response: "Odpoveď",
      reply: "Odpovedať na {type} poznámku",
      reply_to_all_emails: "Odpovedať na všetky emaily",
    },
    previous_note: "Predchádzajúca poznámka",
    hint: {
      note: "Vyvolanie preddefinovaného textu pomocou znaku *. Vyvolanie označenia objektov pomocou znaku @ pre osoby, $ pre majetok, % pre dokumenty a # pre hlásenia.",
    },
  },
  issue_feedback: {
    issue_feedback: "Spätná väzba",
    issue_feedbacks: "Spätné väzby",
    acc: "spätnú väzbu",
    alert: genericAlertF,
  },
  issue_link: {
    issue_link: "Prepojené hlásenie",
    issue_links: "Prepojené hlásenia",
    acc: "prepojené hlásenie",
    alert: genericAlertN,
    label: {
      type: "Typ",
    },
    link_types: {
      related: "Súvisiace hlásenia",
      duplicate: "Duplikát hlásenia",
    },
  },
  assets_issue: {
    assets_issue: "Majetok na hlásení",
    assets_issues: "Majetok na hláseniach",
    acc: "priradenie majetku k hláseniu",
    issue: "Majetok priradený k hláseniu",
    asset: "Hlásenie priradené k majetku",
    alert: genericAlertM,
    label: {
      solve_status: "Stav riešenia",
      not_run: "Neriešené",
      success: "Úspešná kontrola",
      fail: "Neúspešná kontrola",
      warning: "Varovanie",
    },
  },
  role_user: {
    role_user: "Priradenie používateľa k role",
    role_users: "Priradenia používateľov k rolám",
    acc: "priradenie používateľa k role",
    alert: genericAlertN,
    label: {
      person_setup: "Nastaviť osoby pre rolu",
    },
  },
  team_user: {
    team_user: "Priradenie používateľa k tímu",
    team_users: "Priradenia používateľov k tímom",
    acc: "priradenie používateľa k tímu",
    alert: genericAlertN,
    label: {
      person_setup: "Nastaviť osoby pre tím",
    },
  },
  person_asset: {
    person_asset: "Priradenie osoby k majetku",
    person_assets: "Priradenia osôb k majetku",
    acc: "priradenie osoby k majetku",
    alert: genericAlertN,
  },
  external_guid: {
    external_guid: "Identifikátor",
    external_guids: "Identifikátory",
    acc: "identifikátor",
    alert: genericAlertM,
    bar: "BAR kód",
  },
  jwt_session: {
    jwt_session: "Prihlásené zariadenie",
    jwt_sessions: "Prihlásené zariadenia",
    acc: "prihlásené zariadenie",
    alert: genericAlertN,
    label: {
      actual: "Aktuálne prihlásenie",
      browser: "Prehliadač",
      last_ip: "Posledná IP adresa",
      location: "Poloha",
    },
  },
  tag_definition: {
    tag_definition: "Tag",
    tag_definitions: "Tagy",
    acc: "tag",
    alert: genericAlertM,
    label: {
      color: "Farba",
      without: "Bez tagu",
      add: "Pridať tag",
      new: "Vytvoriť nový tag",
      filter: "Filtrovať",
    },
  },
  issue_priority: {
    issue_priority: "Priorita hlásenia",
    issue_priorities: "Priority hlásení",
    acc: "prioritu hlásenia",
    alert: genericAlertF,
    label: {
      priority: "Priorita",
      order: "Poradie",
      without: "Bez priority",
    },
  },
  person_relation: {
    person_relation: "Vzťah osoby",
    person_relations: "Vzťahy osôb",
    acc: "vzťah osoby",
    alert: genericAlertM,
  },
  profile: {
    profile: "Profil",
    profiles: "Profily",
    acc: "profil",
    settings: "Nastavenia",
    alert: genericAlertM,
    email: "Email",
    change_email: "Zmeniť",
    password: "Heslo",
    change_password: "Zmeniť",
    password_current: "Zadajte Vaše súčasné heslo",
    password_new: "Nové heslo",
    password_new_c: "Potvrďte nové heslo",
    account: "Účet",
    account_security: "Zabezpečenie účtu",
    manage_settings: "Spravujte nastavenia a preferencie svojho účtu",
    preferences: "Preferencie",
    prefer_exact_dates: "Preferovať exaktné dátumy",
    theme: "Téma",
    theme_options: {
      use_system_theme: "Podľa systému",
      dark: "Tmavá",
      light: "Svetlá",
    },
    locale: "Jazyk",
    date_format: "Formát dátumu",
    time_format: "Formát času",
    time_zone: "Časová zóna",
    week_first_day: "Prvý deň v týždni",
    pagination: "Stránkovanie",
    home_page: "Domovská stránka",
    two_factor_auth: "Dvojfaktorová autentifikácia",
    devices: "Zariadenia",
    about: "O aplikácii",
    change_to_ssp: "Prepnúť na Self-Service Portál",
    change_from_ssp: "Prepnúť na Hlavný systém",
    product: {
      more_1:
        "Viac o platforme AUSEMIO a jej licencovaní nájdete na {web}, kde nájdete aj obchodné kontakty.",
      more_2: "V prípade technických otázok nás kontaktujte na {mail}.",
      legal: {
        cookies: "Súbory Cookies",
        gdpr: "Zbieranie Dát",
      },
      install: {
        name: "Názov",
        id: "Identifikátor",
        version: "Verzia",
        administration: "Správca",
      },
    },
  },
  license: {
    license: "Licencia",
    label: {
      type: "Typ používateľa",

      monthly: "Mesačná",
      yearly: "Ročná",
    },
    items: {
      title: "Licencia",
      payment: "Úhrada",
      users: "Používatelia",
      storage: "Úložisko",
      of: "z",
      modules: "Moduly",
      connectors: "Konektory",
    },
  },
  administration: {
    administration: "Administrácia",
    administrations: "Administrácie",
    acc: "administráciu",
    alert: genericAlertF,
  },
  import: {
    import: "Import",
    imports: "Import",
    acc: "import",
    alert: genericAlertM,
    label: {
      link_to: "Nalinkovať dokument na",
      export_question: "Chcete exportovať {model}?",
      export_text: "Vyfiltrované {model} budú exportované v .xlsx formáte",
      custom_export_text: "{model} budú exportované v .xlsx formáte",
      failed_row_number: "Číslo chybného riadka",
      failed_message: "Chybová správa",
      operation: "Operácia",
      status: "Status",
      stop: "Zastaviť import",
    },
  },
  implementation: {
    implementation: "Implementácia",
    implementations: "Implementácie",
    acc: "implementáciu",
    alert: genericAlertF,
    smtp: {
      label: {
        address: "Adresa",
        authentication: "Autentifikácia",
        domain: "Doména",
        host: "Host",
        openssl: "Nastavenie overenia OpenSSL",
        port: "Port",
        starttls: "Povolené STARTTLS",
        tls: "TLS",
        user_name: "Používateľské meno",
      },
    },
    menu: {
      notice: "Oznam",
      calendar: "Kalendár",
      statistics: "Štatistika",
      mail_server: "Emailový server",
      issue_state_transitions: "Prechody medzi stavmi hlásenia",
      user_settings: "Predvolené nastavenia používateľov",
      document_settings: "Nastavenia dokumentov",
      new_passwd: "Nastaviť nové heslo",
      public_form: "Verejný formulár pre nahlasovanie",
      background_jobs: "Práce na pozadí",
      app_settings: "Nastavenia aplikácie",
      installation: "Inštalácia",
      holidays: "Sviatky",
      branding: "Branding",
      ssp_settings: "Nastavenia Self-Service Portálu",
    },
    label: {
      // issue states and priorities dialog
      color: "Farba",
      db_representation: "Reprezentácia v databáze",
      max_filesize: "Maximálna veľkosť v MB",
      compress_dimension: "Maximálny rozmer obrázka pri komprimovaní v px",
      notice: "Oznam",
      setup_notice: "Nastaviť oznam",
      severity: "Závažnosť",
      category: "Vyberte kategóriu pre vygenerovanie import skriptu",
      generate: "Generovať XLSX súbor",
      read_file: "Načítať súbor pre import",
      run_import: "Spustiť import",
      new_import: "Nový import",
      hide_table:
        "Skryť tabuľku (odporúčané pri spracovaní 100 a viac riadkov)",
      public_form: {
        form: "Celý formulár pre nahlasovanie",
        step_2: "Krok 2 (skenovanie QR)",
        step_3: "Krok 3 (poloha)",
      },
      severity_levels: {
        info: "Informácia",
        error: "Chyba",
        success: "Úspech",
        warning: "Varovanie",
      },
      ssp: {
        title: "Hlavička portálu",
        subtitle: "Podtitul portálu",
      },
      documents: {
        person_documents: "Dokumenty osôb",
        person_avatars: "Avatary osôb",
        person_detail: "Detail osôb",
        person_reports: "Reporty osôb",
        asset_documents: "Dokumenty majetkov",
        asset_avatars: "Avatary majetkov",
        asset_detail: "Detail majetkov",
        asset_reports: "Reporty majetkov",
        asset_checklists: "Kontrolné zoznamy majetkov",
        contract_documents: "Dokumenty zmlúv",
        service_documents: "Dokumenty služieb",
        rule_documents: "Dokumenty pravidiel",
        issue_documents: "Dokumenty hlásení",
        issue_detail: "Detail hlásení",
        issue_reports: "Reporty hlásení",
        audit_documents: "Dokumenty auditov",
        audit_evidences: "Evidencia auditov",
        audit_reports: "Reporty auditov",
        price_list_reports: "Reporty cenníkov",
        default_folder_settings: "Predvolené nastavenia ukladania súborov pre:",
      },
      default_email_connector: "Predvolený emailový konektor",
    },
    hint: {
      documents_import: {
        filters: "Dokumenty budú priradené k vyfiltrovaným objektom",
      },
    },
  },
  notice: {
    notice: "Oznam",
    acc: "oznam",
    alert: genericAlertM,
  },
  activity: {
    activity: "Aktivita",
    activities: "Aktivity",
    acc: "aktivitu",
    label: {
      activity_type: "Typ aktivity",
      author_type: "Typ autora",
      changed: "Zmenené",
      changed_at: "Zmenené",
      changed_by: "Zmenil",
      from: "Pred",
      to: "Po",
      diff: "Rozdiely",
      attribute: "Atribút",
    },
    list_label: {
      created_at: "Vytvorené",
      created_by: "Vytvoril",
      activity_type: "Typ aktivity",
      object_type: "Typ objektu",
      object_id: "ID objektu",
      name: "Názov",
      before: "Pred",
      after: "Po",
    },
    activity_types: {
      create: "Vytvorenie",
      update: "Úprava",
      destroy: "Zmazanie",
      log_in: "Prihlásenie",
      log_out: "Odhlásenie",
      other: "Iný",
      archive: "Archivovanie",
      unarchive: "Obnovenie",
    },
    timeline: {
      chips: {
        Issue: "@:issue.issue",
        TagAssignment: "@:tag_definition.tag_definitions",
        EntityDocument: "@:document.documents",
        IssueNote: "@:issue_note.issue_notes",
        IssueFeedback: "@:issue_feedback.issue_feedback",
        AssetsIssue_issue: "@:asset.assets",
        WorkReport: "@:work_report.work_reports",
        Location: "@:location.location",
        IssueLink: "@:issue_link.issue_links",
        Asset: "@:asset.asset",
        PersonAsset: "@:person.persons",
        AssetsIssue_asset: "@:issue.issues",
        ExternalGuid: "@:external_guid.external_guid",
        IssueService: "@:issue_service.issue_service",
      },
      Issue: {
        create: "vytvoril/a toto",
        update: "upravil/a toto",
        destroy: "vymazal/a toto",
        status_change: "zmenil/a stav na",
      },
      Asset: {
        create: "vytvoril/a tento",
        update: "upravil/a tento",
        destroy: "vymazal/a tento",
        archive: "archivoval/a tento",
        unarchive: "obnovil/a tento",
      },
      AssetsIssue: {
        create: "priradil/a majetok k hláseniu",
        update: "upravil/a majetok na hlásení",
        destroy: "odobral/a majetok z hlásenia",
      },
      IssueService: {
        create: "priradil/a hlásenie na službu",
        update: "upravil/a hlásenie",
        destroy: "odobral/a hlásenie zo služby",
      },
      IssueLink: {
        create: "priradil/a",
        update: "upravil/a",
        destroy: "vymazal/a",
      },
      EntityDocument: {
        create: "priradil/a",
        update: "upravil/a",
        destroy: "odobral/a",
      },
      PersonAsset: {
        create: "priradil/a",
        update: "upravil/a",
        destroy: "odobral/a",
      },
      WorkReport: {
        create: "priradil/a",
        update: "upravil/a",
        destroy: "odobral/a",
      },
      ExternalGuid: {
        create: "priradil/a",
        update: "upravil/a",
        destroy: "odobral/a",
      },
      Location: {
        create: "pridal/a",
        update: "upravil/a",
        destroy: "odobral/a",
      },
      IssueNote: {
        create: "pridal/a",
        update: "upravil/a",
        destroy: "odobral/a",
      },
      IssueFeedback: {
        create: "pridal/a",
        destroy: "odobral/a",
      },
      TagAssignment: {
        create: "priradil/a",
        update: "upravil/a",
        destroy: "odobral/a",
      },
      generic: {
        Issue: "hlásenie",
        Asset: "majetok",
        IssueLink: "link na hlásenie",
        AssetsIssue: "",
        IssueService: "",
        IssueNote: "poznámku",
        IssueFeedback: "spätnú väzbu",
        WorkReport: "výkaz práce",
        EntityDocument: "dokument",
        PersonAsset: "osobu",
        ExternalGuid: "identifikátor",
        Location: "polohu",
        TagAssignment: "tag",
      },
    },
  },
  filter: {
    filter: "Filter",
    filters: "Filtre",
    acc: "filter",
    alert: genericAlertM,
    existence_levels: {
      all: "Všetky",
      archived: "Iba archivované",
    },
    issue_closed_levels: {
      all: "Všetky",
      closed: "Iba uzavreté",
    },
    otp_required_for_login_levels: {
      two_factor_auth: "2FA",
      without_two_factor_auth: "Bez 2FA",
    },
    blocked_levels: {
      blocked: "Blokovaní",
      not_blocked: "Neblokovaní",
    },
    on_levels: {
      on: "Zapnuté",
      off: "Vypnuté",
    },
    public_token_valid_levels: {
      public: "Verejné",
      internal: "Interné",
    },
    below_min_levels: {
      below: "Pod minimom",
      above: "Nad minimom",
    },
    above_opt_levels: {
      below: "Pod optimom",
      above: "Nad optimom",
    },
    with_user_levels: {
      with_user: "S používateľom",
      without_user: "Bez používateľa",
    },
    actions: {
      subheaders: {
        savedFilters: "Uložené filtre",
      },
    },
  },
  data_set: {
    data_set: "Filter",
    data_sets: "Filtre",
    acc: "filter",
    alert: genericAlertM,
    label: {
      target_entity: "Cieľový dátový typ",
      definition: "Definícia",
      edit_filter_definition: "Editovať definíciu filtra",
      edit_definition: "Editovať definíciu",
      definition_from_filter: "Načítať definíciu z filtra",
    },
    target_entities: {
      Activity: "@:activity.activity",
      AppliedSla: "SLA",
      Asset: "@:asset.asset",
      AssetCategory: "@:asset_category.asset_category",
      AssetsIssue: "@:checklist.checklist",
      AutomatedAction: "@:automated_action.automated_action",
      Contract: "@:contract.contract",
      DataSet: "@:data_set.data_set",
      Document: "@:document.document",
      ExternalEmail: "@:external_email.external_email",
      Field: "@:field.field",
      Issue: "@:issue.issue",
      Kpi: "@:kpi.kpi",
      Person: "@:person.person",
      PersonCategory: "@:person_category.person_category",
      PriceItem: "@:price_item.price_item",
      PriceItemsWarehouse: "@:price_items_warehouse.price_items_warehouse",
      PriceList: "@:price_list.price_list",
      Report: "@:report.report",
      Requirement: "@:requirement.requirement",
      Risk: "@:risk.risk",
      Role: "@:role.role",
      Service: "@:service.service",
      Snippet: "@:snippet.snippet",
      Subscription: "@:subscription.subscription",
      Task: "@:task.task",
      Threat: "@:threat.threat",
      Translation: "@:translation.translation",
      User: "@:user.user",
      Vulnerability: "@:vulnerability.vulnerability",
      Warehouse: "@:warehouse.warehouse",
      WarehouseTransactionItem:
        "@:warehouse_transaction_item.warehouse_transaction_item",
    },
    multi_operations: {
      create_issue: "Vytvoriť hlásenie",
      link_to_document: "Priradiť dokument",
      change_parent: "Zmeniť umiestnenie v strome",
      link_assets_to_person: "Priradiť k osobe",
      link_persons_to_asset: "Priradiť majetok",
      link_documents_to_entity: "Priradiť k objektu",
      compress_documents: "Komprimovať obrázky",
      tag: "Priradiť tag",
      untag: "Odobrať tag",
      group: "Priradiť do skupiny",
      ungroup: "Odobrať zo skupiny",
      remove_assets_from_person: "Odobrať z osoby",
      archive_multiple: "Archivovať",
      destroy_multiple: "Zmazať",
      export: "Exportovať",
      report: "Generovať report",
    },
    multi_operations_hint: {
      generic:
        "Ostatné operácie nie je možné spustiť, pretože máte vyfiltrovaných viac ako 1000 položiek.",
    },
  },
  report: {
    report: "Report",
    reports: "Reporty",
    acc: "report",
    alert: genericAlertM,
    label: {
      target_entity: "Cieľový dátový typ",
      report_type: "Typ reportu",
      generate: "Generovať",
      submenu: {
        generate_report: "Generovať report",
        subheader: "Reporty",
      },
      contains_qr: "Obsahuje QR kód",
      contains_avatar: "Obsahuje avatara",
    },
    messages: {
      hint: "Report bude vygenerovaný na pozadí a súbor bude uložený do zvoleného priečinka. O dokončení budete informovaný notifikáciou v aplikácii.",
    },
    report_types: {
      single_entity: "Jeden cieľový objekt",
      data_set: "Filter",
    },
    target_entities: {
      Issue: "@:issue.issue",
      Asset: "@:asset.asset",
      Person: "@:person.person",
      PriceList: "@:price_list.price_list",
      Audit: "@:audit.audit",
      Risk: "@:risk.risk",
    },
  },
  automated_action: {
    automated_action: "Automatická akcia",
    automated_actions: "Automatické akcie",
    acc: "automatickú akciu",
    alert: genericAlertF,
    label: {
      automated_action_type: "Typ automatickej akcie",
      run_type: "Typ spustenia",
      definition: "Definícia",
      edit_definition: "Editovať definíciu",
      on: "Zapnutá",
      activity: "Typ aktivity",
      author_type: "Typ autora",
      recipient_type: "Typ príjemcu",
      variable: "Premenná",
    },
    stepper: {
      basic: "Základné nastavenia",
      trigger: "Spúšťač",
      action: "Akcia",
    },
    automated_action_types: {
      notify: "Poslanie notifikácie",
      report: "Generovanie reportu",
      create: "Vytvorenie objektu",
      update: "Úprava objektu",
      archive: "Archivácia objektu",
      destroy: "Zmazanie objektov",
      run_connector: "Spustiť konektor",
    },
    run_types: {
      now: "Okamžite",
      delayed: "Oneskorene",
    },
  },
  holiday: {
    holiday: "Sviatok",
    holidays: "Sviatky",
    acc: "sviatok",
    alert: genericAlertM,
    label: {
      country: "Krajina",
      date: "Dátum",
    },
  },
  sla: {
    sla: "SLA",
    slas: "SLA",
    acc: "SLA",
    alert: genericAlertF,
    label: {
      states: "Stavy",
      response_time: "Čas zareagovania",
      resolution_time: "Čas vyriešenia",
      autoclose_time: "Automaticky uzavrieť vyriešené hlásenia po",
      monday: "Pondelok",
      tuesday: "Utorok",
      wednesday: "Streda",
      thursday: "Štvrtok",
      friday: "Piatok",
      saturday: "Sobota",
      sunday: "Nedeľa",
      holiday: "Sviatok",
      holidays_countries: "Krajiny pre sviatky",
      from: "Od",
      to: "Do",
      estimated_response_time: "Odpoveď - Limit podľa SLA",
      responded_at: "Odpoveď - Skutočný čas",
      estimated_resolution_time: "Vyriešenie - Limit podľa SLA",
      resolved_at: "Vyriešenie - Skutočný čas",
      response_status: "Odpoveď - stav",
      response: "Odpoveď",
      resolution_status: "Vyriešenie - stav",
      resolution: "Vyriešenie",
      nonstop: "Nepretržite",
      standby: "Pohotovosť",
      before_time_runs_out: "pred vypršaním času",
      set_sla_times: "Nastaviť časy SLA",
      set_autoclose_time: "Nastaviť automatické uzavretie hlásení",
    },
    statuses: {
      in_progress: "V procese",
      overdue: "Zmeškaná",
      resolved: "Splnená",
      paused: "Pozdržaná",
      in_progress_n: "V procese",
      overdue_n: "Zmeškané",
      resolved_n: "Splnené",
      paused_n: "Pozdržané",
    },
    message_prefix: {
      future: "Vyprší",
      now: "Vypršala",
    },
  },
  risk_management: {
    risk_management: "Riadenie rizík",
    acc: "riadenie rizík",
    alert: genericAlertN,
  },
  vulnerability: {
    vulnerability: "Zraniteľnosť",
    vulnerabilities: "Zraniteľnosti",
    acc: "zraniteľnosť",
    alert: genericAlertF,
    label: {
      add: "Pridať zraniteľnosť",
    },
  },
  threat: {
    threat: "Hrozba",
    threats: "Hrozby",
    acc: "hrozbu",
    alert: genericAlertF,
    label: {
      add: "Pridať hrozbu",
      confidentiality: "Dopad na dôvernosť",
      integrity: "Dopad na integritu",
      availability: "Dopad na dostupnosť",
      accidental: "Náhodná",
      intentional: "Úmyselná",
      environmental: "Prostredia",
    },
  },
  threat_category: {
    threat_category: "Kategória hrozieb",
    threat_categories: "Kategórie hrozieb",
    acc: "kategóriu hrozieb",
    alert: genericAlertF,
  },
  consequence: {
    consequence: "Následok",
    consequences: "Následky",
    acc: "následok",
    alert: genericAlertM,
  },
  likelihood: {
    likelihood: "Pravdepodobnosť",
    likelihoods: "Pravdepodobnosti",
    acc: "pravdepodobnosť",
    alert: genericAlertF,
  },
  risk_level: {
    risk_level: "Úroveň rizika",
    risk_levels: "Úrovne rizík",
    acc: "úroveň rizika",
    alert: genericAlertF,
    label: {
      color: "Farba",
    },
  },
  risk: {
    risk: "Riziko",
    risks: "Riziká",
    acc: "riziko",
    alert: genericAlertN,
    label: {
      description: "Scenár rizika",
      consequence: "Následok",
      consequenceShort: "N",
      likelihood: "Pravdepodobnosť",
      likelihoodShort: "P",
      risk: "Riziko",
      riskShort: "R",
      not_rated: "Nehodnotené",
      network_graph: "Sieťový Graf",
      effectiveness: "Aplikované",
      planned_effectiveness: "Planovaná aplikácia",
      real_effectiveness: "Skutočná aplikácia",
      reduction: "Váha opatrenia",
      current_risk: "Aktuálne riziko",
      residual_risk: "Reziduálne riziko",
      treatment_kind: "Plán ošetrenia",
      risk_analysis: "Analýza rizík",
      risk_type: "Typ rizika",
      risk_matrix: "Matica rizík",
      show_all_controls: "Zobraziť všetky opatrenia",
      show_zero_risks: "Zobraziť nulové riziká",
      generate_report: "Generovať report rizík",
    },
    treatment_kind: {
      null: "-",
      reduce: "Zníženie",
      accept: "Akceptácia",
      share: "Zdieľanie",
    },
  },
  asset_group: {
    asset_group: "Skupina aktív",
    asset_groups: "Skupiny aktív",
    acc: "skupinu aktív",
    alert: genericAlertF,
    label: {
      add: "Pridať skupinu aktív",
    },
  },
  asset_group_asset: {
    asset_group_asset: "Majetok v skupine aktív",
    asset_group_assets: "Majetky v skupine aktív",
    acc: "majetok v skupine aktív",
    alert: genericAlertM,
  },
  risk_asset_group: {
    risk_asset_group: "Skupina aktív na riziku",
    risk_asset_groups: "Skupiny aktív na riziku",
    acc: "skupiny aktív na riziku",
    alert: genericAlertF,
    label: {
      add: "Pridať skupinu aktív na riziku",
    },
  },
  risk_asset: {
    risk_asset: "Aktívum na riziku",
    risk_assets: "Aktíva na riziku",
    acc: "aktívum na riziku",
    alert: genericAlertN,
    label: {
      add: "Pridať aktívum na riziku",
    },
  },
  asset_link: {
    asset_link: "Odkaz na majetok",
    asset_links: "Odkazy na majetok",
    acc: "odkaz na majetok",
    alert: genericAlertM,
  },
  asset_control: {
    asset_control: "Priradenie opatrenia k majetku",
    asset_controls: "Priradenia opatrení k majetku",
    acc: "priradenie opatrenia k majetku",
    alert: genericAlertN,
  },
  control: {
    control: "Opatrenie",
    controls: "Opatrenia",
    acc: "opatrenie",
    alert: genericAlertN,
    label: {
      add: "Pridať opatrenie",
      applied: "Aplikované opatrenia",
      applied_s: "Aplikované opatrenie",
      add_applied: "Pridať aplikované opatrenie",
      remove_applied: "Odstrániť aplikované opatrenie",
      add_planned: "Pridať plánované opatrenie",
      remove_planned: "Odstrániť plánované opatrenie",
      planned: "Plánované opatrenia",
      control: "1 opatrenie | {n} opatrenia | {n} opatrení",
      note: "Poznámka",
      budget: "Predpokladané náklady",
      time: "Predpokladaná pracnosť",
      deadline: "Termín",
      accept: "Akceptujem",
      warning_message:
        "Pri uložení sa prepíše hodnota aplikovaného opatrenia a vymažú sa všetky ostatné hodnoty.",
      justification: "Odôvodnenie",
      responsible_user: "Zodpovedný používateľ",
    },
  },
  controls_management: {
    controls_management: "Riadenie opatrení",
  },
  audit: {
    audit: "Audit",
    audits: "Audity",
    acc: "audit",
    alert: genericAlertM,
    label: {
      compliance: "Súlad",
      partial_compliance: "Čiastočný súlad",
      non_compliance: "Nesúlad",
      not_applicable: "Neaplikovateľné",
      unrated: "Nehodnotené",
      auditor: "Audítor",
      audit_organization: "Auditovaná organizácia",
      representative: "Zástupca organizácie",
      submission_date: "Dátum odovzdania",
      requirements: "Požiadavky",
      evidence: "Dôkazy",
      questions: "Otázky",
      findings: "Odpovede",
      note: "Poznámky",
      copy_questions: "Skopírovať otázky",
    },
  },
  recommendation: {
    recommendation: "Odporúčané opatrenie",
    recommendations: "Odporúčané opatrenia",
    acc: "odporúčané opatrenie",
    alert: genericAlertN,
  },
  question: {
    question: "Otázka",
    questions: "Otázky",
    acc: "otázku",
    alert: genericAlertF,
    label: {
      question: "Otázka",
      finding: "Odpoveď",
      note: "Poznámka",
    },
  },
  provision_question: {
    provision_question: "Otázka",
    provision_questions: "Otázky",
    acc: "otázku",
    alert: genericAlertF,
  },
  standard_soa_provision: {
    standard_soa_provision: "Požiadavka",
    standard_soa_provisions: "Požiadavky",
    acc: "požiadavku",
    alert: genericAlertF,
  },
  suggestion: {
    suggestion: "Návrh na zlepšenie",
    suggestions: "Návrhy na zlepšenia",
    acc: "návrh na zlepšenie",
    alert: genericAlertM,
  },
  standard: {
    standard: "Norma",
    standards: "Normy",
    acc: "normu",
    alert: genericAlertF,
    laws_standards: "Normy",
    label: {
      label: "Označenie",
      text: "Text",
      valid_from: "Platná od",
      valid_to: "Platná do",
    },
  },
  standard_soa: {
    standard_soa: "Vyhlásenie o aplikovateľnosti",
    standard_soas: "Vyhlásenia o aplikovateľnosti",
    acc: "vyhlásenie o aplikovateľnosti",
    alert: genericAlertN,
    label: {
      reason: "Dôvod",
      applicable: "Aplikovateľné",
    },
  },
  section: {
    section: "Sekcia",
    sections: "Sekcie",
    acc: "sekciu",
    alert: genericAlertF,
  },
  provision: {
    provision: "Ustanovenie",
    provisions: "Ustanovenia",
    acc: "ustanovenie",
    alert: genericAlertN,
  },
  requirement: {
    requirement: "Požiadavka",
    requirements: "Požiadavky",
    acc: "požiadavku",
    alert: genericAlertF,
    label: {
      status: "Stav",
    },
  },
  evaluation: {
    evaluation: "Ohodnotenie",
  },
  issue_tab: {
    redirect: "Otvoriť v Hláseniach",
  },
  warehouse_transaction: {
    warehouse_transaction: "Transakcia",
    warehouse_transactions: "Transakcie",
    acc: "transakciu",
    alert: genericAlertF,
    label: {
      transaction_type: "Typ transakcie",
    },
  },
  warehouse_transaction_item: {
    warehouse_transaction_item: "Položka transakcie",
    warehouse_transaction_items: "Položky transakcie",
    acc: "položku transakcie",
    alert: genericAlertF,
  },
  warehouse_batch: {
    warehouse_batch: "Šarža",
  },
  tag_assignment: {
    tag_assignment: "Priradenie tagu",
    alert: genericAlertN,
    acc: "priradenie tagu",
  },
  price_items_warehouse: {
    price_items_warehouse: "Skladová položka",
    price_items_warehouses: "Skladové položky",
    acc: "skladovú položku",
    alert: genericAlertF,
  },
  price_list_item: {
    price_list_item: "Položka cenníka",
  },
  category_hierarchy: {
    category_hierarchy: "Prepojenie kategórií",
  },
  background_job: {
    background_job: "Práca na pozadí",
    background_jobs: "Práce na pozadí",
    acc: "prácu na pozadí",
    alert: genericAlertF,
    label: {
      last_error: "Posledná chyba",
    },
  },
  external_password: {
    external_password: "Externé heslo",
  },
  translation: {
    translation: "Preklad",
    translations: "Preklady",
    acc: "preklad",
    alert: genericAlertM,
    label: {
      key: "Kľúč",
      en: "Preklad EN",
      sk: "Preklad SK",
      en_short: "EN",
      sk_short: "SK",
    },
  },
  cia: {
    cia: "CIA",
  },
  risk_control: {
    risk_control: "Opatrenie na riziku",
    risk_controls: "Opatrenia na riziku",
    acc: "opatrenie na riziku",
    alert: genericAlertN,
  },
  issue_service: {
    issue_service: "Hlásenie na službe",
  },
  tiptap_editor: {
    bold: "Tučné",
    italic: "Kurzíva",
    strike: "Prečiarknuté",
    underline: "Podčiarknuté",
    highlight: "Zvýraznenie",
    text_color: "Farba textu",
    header_1: "Nadpis 1",
    header_2: "Nadpis 2",
    header_3: "Nadpis 3",
    bullet_list: "Odrážkový zoznam",
    ordered_list: "Číslovaný zoznam",
    align_left: "Zarovnať vľavo",
    align_center: "Zarovnať na stred",
    align_right: "Zarovnať vpravo",
    table: "Vložiť tabuľku",
    add_column_before: "Pridať stĺpec pred",
    add_column_after: "Pridať stĺpec za",
    delete_column: "Vymazať stĺpec",
    add_row_before: "Pridať riadok pred",
    add_row_after: "Pridať riadok za",
    delete_row: "Vymazať riadok",
    delete_table: "Vymazať tabuľku",
    leave_table: "Opustiť tabuľku",
    link: "Vložiť odkaz",
    image: "Vložiť obrázok",
    invalid_image_type: "Prosím vyberte platný súbor obrázka.",
    mentions: "Zmienky",
    placeholder: "Napíšte niečo...",
    label: {
      link: "Odkaz",
      link_text: "Text odkazu",
      link_url: "URL odkazu",
    },
    toggle_header_row: "Prepnúť hlavičkový riadok",
  },
  knowledge_base: {
    knowledge_base: "Znalostná báza",
    knowledge_bases: "Znalostné bázy",
    acc: "znalostnú bázu",
    alert: genericAlertF,
    pinned: "Pripnuté",
    recommended: "Odporúčané",
    search_results: "Výsledky vyhľadávania",
    recent_articles: "Nedávne články",
    no_results: "Žiadne články nenájdené",
    no_context: "Kontext nie je dostupný",
    view_all: "Zobraziť všetky",
    search_articles: "Hľadať články v znalostnej báze",
    pin_to_object: "Pripnúť k objektu",
    unpin_from_object: "Odopnúť z objektu",
    copy_link: "Kopírovať odkaz na článok",
    copy_article: "Kopírovať obsah článku",
    link_copied: "Odkaz na článok skopírovaný do schránky",
    article_copied: "Obsah článku skopírovaný do schránky",
    copy_failed: "Nepodarilo sa skopírovať do schránky",
    article_pinned: "Článok úspešne pripnutý",
    article_unpinned: "Článok úspešne odopnutý",
  },
  article: {
    article: "Článok",
    articles: "Články",
    acc: "článok",
    alert: genericAlertM,
    label: {
      title: "Názov",
      content: "Obsah",
      type: "typ",
      keywords: "Kľúčové slová",
      author: "Autor",
      created_at: "Vytvorené",
      created_by: "Vytvoril",
      published_by: "Publikoval",
      withdraw_article: "Zrušiť publikovanie článku",
      updated_at: "Aktualizované",
      likes: "Páči sa mi",
      dislikes: "Nepáči sa mi",
      version: "Verzia",
      publish_article: "Publikovať článok",
    },
    article_types: {
      faq: "Často kladené otázky",
      how_to: "Návody",
      troubleshooting: "Riešenie problémov",
    },
    article_statuses: {
      draft: "Koncept",
      published: "Publikovaný",
      archived: "Archivovaný",
    },
  },
  article_pin: {
    article_pin: "Pripnutie článku",
    article_pins: "Pripnutia článkov",
    acc: "pripnutie článku",
    alert: genericAlertN,
  },
  link: {
    link: "Odkaz",
    links: "Odkazy",
    acc: "odkaz",
    alert: genericAlertM,
  },
  portal: {
    select_service: "Vyberte službu pre zobrazenie detailu",
    no_services: "Žiadne dostupné služby",
    open_issues: "Otvorené hlásenia",
    new_issues: "Nové hlásenia",
    pending_approvals: "Čakajúce schválenia",
    resolved_today: "Vyriešené dnes",
    provided_services: "Poskytované služby",
    from_last_week: "z minulého týždňa",
    available_to_you: "dostupné pre vás",
    recent_activity: "Nedávna aktivita",
    quick_actions: "Rýchle akcie",
    service_details: "Detaily služby",
    create_issue: "Vytvoriť hlásenie",
    service_information: "Informácie o službe",
    active: "Aktívna",
    service_id: "ID služby",
    recent_issues: "Nedávne hlásenia",
    all_issues: "Všetky hlásenia",
    no_recent_issues: "Nenašli sa žiadne nedávne hlásenia",
    view_all: "Zobraziť všetko",
    show_less: "Zobraziť menej",
    view_all_open_issues: "Zobraziť všetky otvorené hlásenia",
    view_pending_approvals: "Zobraziť hlásenia čakajúce na schválenie",
    view_resolved_today: "Zobraziť hlásenia vyriešené dnes",
    statistics: "Štatistiky hlásení",
    new: "Nové",
    in_progress: "Prebieha",
    resolved: "Vyriešené",
    closed: "Uzatvorené",
    quick_links: "Rýchle odkazy",
    create_new_issue: "Vytvoriť nové hlásenie",
    view_my_issues: "Zobraziť moje hlásenia",
    request_service: "Požiadať o službu",
    knowledge_base: "Vedomostná databáza",
    submit_new_request: "Odoslať nové hlásenie",
    view_all_issues: "Zobraziť všetky hlásenia",
    service_documentation: "Dokumentácia služby",
    contact_support: "Kontaktovať podporu",
    view_details: "Zobraziť detail",
    no_services_available:
      "Momentálne nie sú k dispozícii žiadne služby. Prosím, skúste to neskôr.",
    popular_articles: "Najpopulárnejšie články",
    helpful_resources: "Užitočné zdroje",
    no_notes: "Zatiaľ žiadne poznámky",
    no_documents: "Žiadne priložené dokumenty",
    create_incident: "Nahlásiť incident",
    create_request: "Vytvoriť požiadavku",
    // Approval
    approval_required: "Vyžaduje sa vaše schválenie",
    approval_description:
      "Toto hlásenie bolo vyriešené a čaká na vaše schválenie",
    approval_note: "Pridať poznámku",
    approval_note_accept_placeholder:
      "Popíšte prečo akceptujete toto riešenie...",
    approval_note_reject_placeholder:
      "Prosím vysvetlite prečo zamietate toto riešenie...",
    approval_note_required: "Pri zamietnutí je poznámka povinná",
    approval_predefined_note:
      "Akceptujem toto hlásenie a súhlasím s jeho uzavretím.",
    accept_solution: "Akceptovať riešenie",
    reject_solution: "Zamietnuť riešenie",
    confirm_accept: "Potvrdiť akceptáciu",
    confirm_reject: "Potvrdiť zamietnutie",
    feedback_title: "Ohodnoťte Vašu skúsenosť",
    feedback_subtitle: "Ako ste spokojný s vyriešením?",
    unread: "Neprečítaná",
    unread_notifications: "Neprečítané",
    read_notifications: "Prečítané",
    archived: "Archivovaná",
  },
};

export default sk;
